import { useState, useEffect, useRef } from 'react';
import { storage, db, auth, messaging, functions } from './firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, collectionGroup, addDoc, query, orderBy, onSnapshot, doc, setDoc, deleteDoc, getDocs, where, limit, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { PlayCircle, Camera, Video, Coins, Home, Tv, MessageCircle, User, Plus, Search, Share2, Mic, Clover, Gift } from 'lucide-react';
import './App.css';
import Perfil from './Perfil';
import ErrorBoundary from './ErrorBoundary.jsx';
import LiveCampo from './LiveCampo';
import CadernetaGaleria from './CadernetaGaleria';
import { enviarNotificacao } from "./notificacoesService";
import ListaNotificacoes from './ListaNotificacoes';
import { dispararPushNoBolso } from './backendNotificacoes';
import { garantirFichaUtilizador, observarSaldo, moverSaldo } from './saldoUtilizador';
import { getToken } from "firebase/messaging";
import MenuPresentes from './MenuPresentes';
import AgoraRTC from "agora-rtc-sdk-ng";
import { AgoraRTCProvider } from "agora-rtc-react";
import BancadaSala from './BancadaSala';
import TelevisaoListas from './TelevisaoListas';
import ArenaPK from './ArenaPK';
import JogosLigaPK from './JogosLigaPK';
import TorneiosPK from './TorneiosPK';
import Levantamentos from './Levantamentos';
import { AGORA_APP_ID } from "./agora-config";


// IMPORT DAS ARTES DE FUNDO E ÍCONES ADICIONAIS DO PROJETO
import fundoLuckys from './assets/fundos/fundoLuckys.webp';
import fundoVideoImg from './assets/fundos/fundoVideo.webp';
import fundoAudioImg from './assets/fundos/fundoAudio.webp';
import fundoPerfilImg from './assets/fundos/fundoPerfil.webp';

const textosGlobal = {
  pt: {
    entrada: {
      titulo: "GAME FUT LIVE ⚽",
      fase: "📋 DIRETRIZES DE SEGURANÇA DO ESTÁDIO",
      regras: [
        "• Proibido a menores de <strong>18 anos</strong>.",
        "• Proibida a aparição de menores nas câmaras ao vivo ou em publicações (fotos/vídeos).",
        "• Proibido o consumo de tabaco, álcool ou atos obscenos.",
        "• Conteúdo inadequado ou abusores serão removidos em 24h.",
        "• Disponíveis ferramentas de denúncia e bloqueio na app."
      ],
      aceite: "Ao entrar, aceitas todas as regras e políticas da app.",
      botao: "ENTRAR NO ESTÁDIO ⚽"
    },
    comentarios: {
      titulo: "Comentários ⚽",
      vazio: "Ainda ninguém comentou. Sê o primeiro! 🏆",
      placeholder: "Escreve um comentário..."
    },
    botoes: {
      caderneta: "CROMOS",
      presentes: "GIFT",
      enviar: "ENVIAR"
    }
  },
  en: {
    entrada: {
      titulo: "GAME FUT LIVE ⚽",
      fase: "📋 STADIUM OFFICIAL SAFETY GUIDELINES",
      regras: [
        "• Prohibited for minors under <strong>18 years old</strong>.",
        "• The appearance of minors on live cameras or in posts (photos/videos) is prohibited.",
        "• Consumption of tobacco, alcohol, or obscene acts is prohibited.",
        "• The user is solely responsible for their content.",
        "• Sharing obscene photos/videos is prohibited."
      ],
      aceite: "By entering, you accept all the app rules and policies.",
      botao: "ENTER THE STADIUM ⚽"
    },
    comentarios: {
      titulo: "Comments ⚽",
      vazio: "No comments yet. Be the first! 🏆",
      placeholder: "Write a comment..."
    },
    botoes: {
      caderneta: "STICKERS",
      presentes: "GIFT",
      enviar: "SEND"
    }
  },
  es: {
    entrada: {
      titulo: "GAME FUT LIVE ⚽",
      fase: "📋 PAUTAS OFICIALES DE SEGURIDAD DEL ESTADIO",
      regras: [
        "• Prohibido para menores de <strong>18 años</strong>.",
        "• Está prohibida la aparición de menores en cámaras en vivo o en publicaciones (fotos/videos).",
        "• Prohibido el consumo de tabaco, alcohol o actos obscenos.",
        "• El usuario es el único responsable de su contenido.",
        "• Prohibido compartir fotos/videos obscenos."
      ],
      aceite: "Al entrar, aceptas todas las reglas y políticas de la app.",
      botao: "ENTRAR AL ESTADIO ⚽"
    },
    comentarios: {
      titulo: "Comentarios ⚽",
      vazio: "Aún no hay comentarios. ¡Sé el primero! 🏆",
      placeholder: "Escribe un commentario..."
    },
    botoes: {
      caderneta: "CROMOS",
      presentes: "GIFT",
      enviar: "ENVIAR"
    }
  },
  fr: {
    entrada: {
      titulo: "GAME FUT LIVE ⚽",
      fase: "📋 DIRECTIVES OFFICIELLES DE SÉCURITÉ DU STADE",
      regras: [
        "• Interdit aux mineurs de moins de <strong>18 ans</strong>.",
        "• L'apparition de mineurs sur les caméras en direct ou dans les publications (photos/vidéos) est interdite.",
        "• Consommation de tabac, d'alcool ou d'actes obscènes interdite.",
        "• L'utilisateur est le seul responsable de son contenu.",
        "• Le partage de photos/vidéos obscènes est interdit."
      ],
      aceite: "En entrant, vous acceptez toutes les règles et politiques de l'application.",
      botao: "ENTRER DANS L'STADE ⚽"
    },
    comentarios: {
      titulo: "Commentaires ⚽",
      vazio: "Pas encore de commentaires. Soyez le premier! 🏆",
      placeholder: "Écrire un commentaire..."
    },
    botoes: {
      caderneta: "AUTOCOLLANTS",
      presentes: "GIFT",
      enviar: "ENVOYER"
    }
  }
};

// Deteta automaticamente o idioma do dispositivo
const idiomaDispositivo = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
// Define as variáveis de tradução com base no idioma detetado (Inglês como padrão se falhar)
const t = textosGlobal[idiomaDispositivo] || textosGlobal.en;
const tEntrada = t.entrada; // Mantém a tua compatibilidade total para o ecrã de áudio sem quebrar nada!

// COMPONENTE PARA CARREGAR E EXIBIR RESPOSTAS RECUADAS WITH REPLY SUPPORT
const ItemRespostas = ({ db, auth, postId, comentarioId, setDadosUtilizador, setPerfilVisitado, setEcraAtivo, setMostrarComentarios, setComentarioAInteragir, paiCompleto }) => {
  const [respostas, setRespostas] = useState([]);

  // Dicionário localizado local para ações rápidas de subcomentários
  const tSub = {
    pt: { responder: "Responder", apagar: "Apagar", confirm: "Queres mesmo apagar a tua resposta? ⚽" },
    en: { responder: "Reply", apagar: "Delete", confirm: "Do you really want to delete your reply? ⚽" },
    es: { responder: "Responder", apagar: "Eliminar", confirm: "¿Realmente quieres eliminar tu respuesta? ⚽" },
    fr: { responder: "Répondre", apagar: "Supprimer", confirm: "Voulez-vous vraiment supprimer votre réponse? ⚽" }
  }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || { responder: "Reply", apagar: "Delete", confirm: "Do you really want to delete your reply? ⚽" };

  useEffect(() => {
    let unsub;
    import('firebase/firestore').then(({ collection, query, orderBy, onSnapshot }) => {
      const q = query(collection(db, "posts", postId, "comentarios", comentarioId, "respostas"), orderBy("criadoEm", "asc"));
      unsub = onSnapshot(q, (snap) => {
        setRespostas(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      });
    });
    return () => { if (unsub) unsub(); };
  }, [postId, comentarioId]);

  if (respostas.length === 0) return null;

  return (
    <div style={{ marginLeft: '30px', marginTop: '12px', paddingLeft: '10px', borderLeft: '2px solid #222' }}>
      {respostas.map(resp => (
        <div key={resp.id} style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <img 
            src={resp.userFoto || "https://gravatar.com"} 
            style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover', marginTop: '2px', cursor: 'pointer' }}
            onClick={() => {
              setPerfilVisitado({ uid: resp.userId });
              setEcraAtivo('perfil');
              setMostrarComentarios(false);
            }}
            alt=""
          />
          <div style={{ flex: 1 }}>
            <span 
              onClick={() => {
                setPerfilVisitado({ uid: resp.userId });
                setEcraAtivo('perfil');
                setMostrarComentarios(false);
              }}
              style={{ color: '#39FF14', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}
            >
              {resp.userName}
            </span>
            <span style={{ color: '#ccc', fontSize: '13px', display: 'block', marginTop: '2px' }}>{resp.texto}</span>
            
            {/* AÇÕES DA SUB-RESPOSTA LOCALIZADAS */}
            <div style={{ display: 'flex', gap: '15px', marginTop: '4px', alignItems: 'center' }}>
              <span 
                onClick={() => setComentarioAInteragir({ ...paiCompleto, userName: resp.userName })}
                style={{ color: '#666', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {tSub.responder}
              </span>

              {resp.userId === auth.currentUser?.uid && (
                <span 
                  onClick={async () => {
                    if (window.confirm(tSub.confirm)) {
                      try {
                        const { doc, deleteDoc } = await import('firebase/firestore');
                        await deleteDoc(doc(db, "posts", postId, "comentarios", comentarioId, "respostas", resp.id));
                      } catch (e) { console.error("Erro ao apagar resposta:", e); }
                    }
                  }}
                  style={{ color: '#ff4444', fontSize: '11px', cursor: 'pointer' }}
                >
                  {tSub.apagar}
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

function Feed({ postParaAbrirLink }) {
    const [mostrarAlertaSom, setMostrarAlertaSom] = useState(true);

    // DETETOR DE LINKS DO WHATSAPP E NOTIFICAÇÕES RICAS
  useEffect(() => {
    if (!postParaAbrirLink) return;
    
    const carregarPostDoLink = async () => {
      try {
        const { doc, getDoc } = await import('firebase/firestore');
        const postRef = doc(db, "posts", postParaAbrirLink);
        const postSnap = await getDoc(postRef);
        
        if (postSnap.exists()) {
          const dadosPost = { id: postSnap.id, ...postSnap.data() };
          setIdPostAtivo(dadosPost);
          setMostrarComentarios(true); // Abre a cortina automática do post

          // SE FOR UM PRESENTO VINDO DO SININHO, DISPARA O STICKER NO ECRÃ!
          // Procura se no teu histórico de notificações há um presente associado a este post
          const params = new URLSearchParams(window.location.search);
          const urlDoSticker = params.get('stickerUrl'); 
          if (urlDoSticker) {
            setPresenteAtivo({ postId: postSnap.id, url: urlDoSticker });
          }
        }
      } catch (e) {
        console.error("Erro ao abrir link/notificação:", e);
      }
    };
    
        carregarPostDoLink();
  }, [postParaAbrirLink]);

    // DETETOR DO BOTÃO AO VIVO DO PERFIL
  useEffect(() => {
    const escutarOrdemDeAbrirLive = async (e) => {
      if (e.detail) {
        // Se for o dono a abrir a sua própria live, ativa o documento no Firebase
                // Se for o dono a abrir a sua própria live, faz a faxina total e ativa o sinal (BLOCO 7 DO TOSHIBA)
        if (e.detail.uid === auth.currentUser?.uid) {
          try {
            const { doc, setDoc, deleteDoc, getDocs, collection, serverTimestamp } = await import('firebase/firestore');
            const meuIdDono = e.detail.uid;

            // 1. Limpa todas as mensagens presas no chat do canal da sessão anterior
            const chatDocs = await getDocs(collection(db, "lives_activas", meuIdDono, "chat"));
            for (const msgDoc of chatDocs.docs) {
              await deleteDoc(doc(db, "lives_activas", meuIdDono, "chat", msgDoc.id));
            }

            // 2. Limpa e destrói os espetadores fantasma da bancada antiga
            const assistindoDocs = await getDocs(collection(db, "lives_activas", meuIdDono, "assistindo"));
            for (const astDoc of assistindoDocs.docs) {
              await deleteDoc(doc(db, "lives_activas", meuIdDono, "assistindo", astDoc.id));
            }

            // 3. Limpa a lista negra de banidos da sessão anterior
            const banDocs = await getDocs(collection(db, "lives_activas", meuIdDono, "banidos"));
            for (const banDoc of banDocs.docs) {
              await deleteDoc(doc(db, "lives_activas", meuIdDono, "banidos", banDoc.id));
            }

            // 3.5 Limpa o RANKING de presentes da sessão anterior. Rede de segurança:
            // o "ENCERRAR" normal já limpa o ranking, mas se a live anterior caiu sem
            // fechar (browser fechado, crash, queda de rede), o ranking ficaria preso e
            // a nova live começaria com os presenteadores antigos. Assim começa SEMPRE a 0.
            const rankingDocs = await getDocs(collection(db, "lives_activas", meuIdDono, "ranking"));
            for (const rDoc of rankingDocs.docs) {
              await deleteDoc(doc(db, "lives_activas", meuIdDono, "ranking", rDoc.id));
            }

            // 4. NOTA: não apagamos o documento principal — o setDoc abaixo substitui-o por
            // completo. Apagar criava um instante de "live inexistente" que expulsava
            // os espetadores com o alerta falso de "transmissão encerrada".

            // 5. CRIA O DOCUMENTO DO ZERO TOTALMENTE FRESCO E ONLINE!
            await setDoc(doc(db, "lives_activas", meuIdDono), {
              uid: meuIdDono,
              userName: auth.currentUser?.displayName || e.detail.donoNome,
              userFoto: auth.currentUser?.photoURL || "",
              status: "online",
              totalTapTaps: 0,
              // O contador da Claque pertence estritamente a esta sessão de stream:
              // arranca SEMPRE a 0 em cada nova criação de live (5000 é a meta).
              tapsClaque: 0,
              criadoEm: serverTimestamp(),
              presenteAnimacao: null,
              presenteTexto: ""
            });

  console.log("Faxina atómica concluída. Estádio pronto para o espetáculo! 🏟️");
            // ==========================================================
            // ALERTA DE LIVE EM MASSA E DISPARO PUSH (BLOCO 9 DO TOSHIBA)
            // ==========================================================
            const seguidoresRef = collection(db, "utilizadores", meuIdDono, "followers");
            const snapSeguidoresLive = await getDocs(seguidoresRef);
            const meuNomeDono = auth.currentUser?.displayName || e.detail.donoNome;

            // Dicionário de notificações push para utilizadores fora da app
            const textosPushLive = {
              pt: "está em DIRETO no estádio! Vem ver!",
              en: "is LIVE in the stadium! Come watch!",
              es: "¡está en DIRECTO en el estadio! ¡Ven a ver!",
              fr: "est en DIRECT dans le stade ! Viens voir !"
            };

            snapSeguidoresLive.forEach(async (docSeguidor) => {
              // 1. Alerta dentro da aplicação (Sininho)
              enviarNotificacao(
                docSeguidor.id,
                meuIdDono,
                meuNomeDono,
                "live"
              );
              
              // 2. Alerta fora da aplicação (Vibrar no bolso via Push com idioma do seguidor)
              if (typeof dispararPushNoBolso === 'function') {
                // Procura o idioma do seguidor na base de dados para mandar a push correta
                let idiomaSeguidor = "en";
                try {
                  const { doc, getDoc } = await import('firebase/firestore');
                  const segSnap = await getDoc(doc(db, "utilizadores", docSeguidor.id));
                  if (segSnap.exists() && segSnap.data().idioma) {
                    idiomaSeguidor = segSnap.data().idioma.split('-')[0];
                  } else {
                    idiomaSeguidor = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
                  }
                } catch (e) {
                  idiomaSeguidor = "en";
                }

                const msgPush = textosPushLive[idiomaSeguidor] || textosPushLive.en;

                dispararPushNoBolso(
                  docSeguidor.id, 
                  "GAME FUT LIVE ⚽", 
                  `${meuNomeDono} ${msgPush}`
                );
              }
            });
            console.log("Alertas de transmissão enviados com sucesso! 🚀");
          } catch (erroFirebase) {
            console.error("Erro na faxina de arranque da live:", erroFirebase);
          }
        }

        setDadosUtilizador({ uid: e.detail.uid, donoNome: e.detail.donoNome });
        setEcraAtivo('live_campo');
      }
    };

    window.addEventListener('abrirLive', escutarOrdemDeAbrirLive);
    return () => {
      window.removeEventListener('abrirLive', escutarOrdemDeAbrirLive);
    };
  }, []);

  const [usuarioSubiuScroll, setUsuarioSubiuScroll] = useState(false);
  const [meusSeguidos, setMeusSeguidos] = useState([]);

    // SENSOR REATIVO DE MÁXIMA SEGURANÇA: Lê os teus seguidores (followers) em tempo real
  const [meusSeguidoresIds, setMeusSeguidoresIds] = useState([]);

    useEffect(() => {
    const meuUuid = auth.currentUser?.uid;
    if (!meuUuid || !db) return;

    // UNIFICAÇÃO UNIVERSAL: Aponta strictly para a coleção 'seguindo' (as pessoas que tu segues)
    const seguindoRef = collection(db, "utilizadores", meuUuid, "seguindo");
    
    const unsubscribeSeguidores = onSnapshot(seguindoRef, (snapshot) => {
      const ids = snapshot.docs.map(doc => doc.id);
      setMeusSeguidoresIds(ids);
    }, (error) => {
      console.error("Erro síncrono ao escutar a coleção de seguidos do TikTok:", error);
    });

    return () => unsubscribeSeguidores();
  }, [db]);

  // --- VARIÁVEIS DO FEED E PUBLICAÇÕES ---
  const [posts, setPosts] = useState([]);
    // 📱 ESTADOS DO FILTRO ESTILO TIKTOK ("TODOS" / "A SEGUIR")
  const [abaFiltroTikTok, setAbaFiltroTikTok] = useState('todos'); // 'todos' ou 'seguir'

  const [abaAtual, setAbaAtual] = useState('videos');
  const [carregando, setCarregando] = useState(false);
  const [idPostAtivo, setIdPostAtivo] = useState(null);
  const [legenda, setLegenda] = useState('');
  const [arquivoParaPostar, setArquivoParaPostar] = useState(null);
  const [somAtivo, setSomAtivo] = useState(false);

    // 🔒 TRANCA ANTI-REPETIÇÃO: Bloqueia cliques duplos ao publicar posts
  const [publicando, setPublicando] = useState(false);

    // 🔍 ESTADO DA PESQUISA DE AMIGOS NO BALNEÁRIO
  const [pesquisaBalneario, setPesquisaBalneario] = useState("");

  // --- VARIÁVEIS DOS COMENTÁRIOS ---
  const [mostrarComentarios, setMostrarComentarios] = useState(false);
  const [novoComentario, setNovoComentario] = useState('');
  const [listaComentarios, setListaComentarios] = useState([]);
  const [comentarioAInteragir, setComentarioAInteragir] = useState(null);

  // --- VARIÁVEIS DOS PRESENTES E STICKERS ---
  const [mostrarPresentes, setMostrarPresentes] = useState(false);
  const [presenteAtivo, setPresenteAtivo] = useState(null);

    // --- VARIÁVEIS FINANCEIRAS E CARTEIRA ---
  const [mostrarMenuSaldo, setMostrarMenuSaldo] = useState(false);
  const [saldoBolas, setSaldoBolas] = useState(0);
    window.saldoBolasGlobal = saldoBolas;

  // --- VARIÁVEIS DE NAVEGAÇÃO E SISTEMA ---
  const [ecraAtivo, setEcraAtivo] = useState('feed');
  const [dadosUtilizador, setDadosUtilizador] = useState(null);
  const [perfilVisitado, setPerfilVisitado] = useState(null);
  // Perfil de um espetador aberto POR CIMA da live (sem desmontar a LiveCampo,
  // para que a ligação Agora não se perca ao voltar à transmissão).
  const [perfilSobreLive, setPerfilSobreLive] = useState(null);
  const [mostrarListaPartilha, setMostrarListaPartilha] = useState(false);
  const [somAtivoGlobal, setSomAtivoGlobal] = useState(false);
  const [utilizadoresApp, setUtilizadoresApp] = useState([]);
  const [postAPartilharInterno, setPostAPartilharInterno] = useState(null);
  const [resultadosPesquisa, setResultadosPesquisa] = useState([]);

  // --- VARIÁVEIS DO PERFIL ---
  const [abaGrelha, setAbaGrelha] = useState('videos');

  // 🔍 FILTRAGEM DINÂMICA DE POSTS SEGUROS (TODOS / A SEGUIR)
  const postsFiltradosTikTok = posts.filter(post => {
    if (abaFiltroTikTok === 'seguir') {
      // FIX: Lê de forma segura a lista de quem TU segues (usa dadosUtilizador ou fallback vazio para evitar crash)
      const listaSeguidosValida = Array.isArray(dadosUtilizador?.seguindoIds) ? dadosUtilizador.seguindoIds : [];
      
      // Se não segues ninguém, esconde os posts desta aba
      if (listaSeguidosValida.length === 0) return false;

      // Captura o ID do criador do post de forma limpa
      const idCriadorPost = String(post?.userId || post?.uid || post?.idCriador || "").trim();
      if (!idCriadorPost) return false;

      // Só mostra o post se o criador estiver na tua lista de seguidos
      return listaSeguidosValida.map(String).includes(idCriadorPost);
    }
    // Na aba 'Todos', exibe tudo a 100% normalmente
    return true;
  });

  const [mostrarListaLikes, setMostrarListaLikes] = useState(false); // Ativa a tua lista do coração!

  // --- VARIÁVEIS DO BALNEÁRIO (PRIVATE CHAT) ---
  const [conversaAtiva, setConversaAtiva] = useState(null);
  const [mensagemTexto, setMensagemTexto] = useState("");
  const [mensagensChat, setMensagensChat] = useState([]);
  const [abaBalneario, setAbaBalneario] = useState('alertas');
  const [notificacaoAtiva, setNotificacaoAtiva] = useState(false);
  const messagesEndRef = useRef(null);

  // --- VARIÁVEIS DE SEGURANÇA E UTILIZADORES ---
  const [utilizadores, setUtilizadores] = useState([]);
  const [meusBloqueados, setMeusBloqueados] = useState([]);
  const [quemMeBloqueou, setQuemMeBloqueou] = useState([]);

  useEffect(() => {
  const meuId = auth.currentUser?.uid;
  if (!meuId) return;

  const q = collection(db, "utilizadores", meuId, "seguindo");
  const unsub = onSnapshot(q, (snap) => {
    setMeusSeguidos(snap.docs.map(doc => doc.id));
  });

  return () => unsub();
}, []);

useEffect(() => {
    const ativarNotificacoesReais = async () => {
      if (!auth.currentUser) return;

      // Sem API de Push (Safari do iPhone fora do ecrã inicial) não há nada a
      // fazer aqui — e insistir só gera erros na consola.
      if (!messaging || typeof Notification === 'undefined') return;

      try {
        // Aguarda que o trabalhador (Service Worker) esteja 100% pronto
        const registo = await navigator.serviceWorker.ready;
        
        const permissao = await Notification.requestPermission();
        
        if (permissao === 'granted') {
          // Gera o Token ligando-o diretamente ao trabalhador registado
          const token = await getToken(messaging, { 
            vapidKey: 'BO3ihJ6xoTsCym31Nia2sQCDpAT_IopFY5iMpDVrwmHAnAvCwWuVKfymP0WDVbfdc-6bcBmlLIMkWIWtiBsqzR0',
            serviceWorkerRegistration: registo
          });
          
          if (token) {
            const userRef = doc(db, "utilizadores", auth.currentUser.uid);
            // setDoc com merge em vez de updateDoc: o updateDoc atira
            // "No document to update" quando a ficha ainda não existe, e esse
            // erro aparecia na consola em cada arranque.
            await setDoc(userRef, { fcmToken: token }, { merge: true });
            console.log("Sistema Push pronto para o mundo! ⚽");
          }
        }
      } catch (erro) {
        console.error("Erro no sistema Push:", erro);
      }
    };

    ativarNotificacoesReais();
  }, [auth.currentUser]);

  useEffect(() => {
    // SENSOR DO LINK DIRETO DAS LIVES (BLOCO 2 DO TOSHIBA)
    const paramsLive = new URLSearchParams(window.location.search);
    const idLiveDoLink = paramsLive.get('live');

    if (idLiveDoLink && ecraAtivo !== 'live_campo') {
      import('firebase/firestore').then(async ({ doc: fDoc, getDoc: fGetDoc }) => {
        try {
          const snap = await fGetDoc(fDoc(db, "lives_activas", idLiveDoLink));

          if (snap.exists() && snap.data()?.status !== "encerrada") {
            setDadosUtilizador({ id: idLiveDoLink, ...snap.data(), uid: idLiveDoLink });
            setEcraAtivo('live_campo');
          } else {
            alert("Esta Live já terminou ou não está disponível! 🏟️");
          }
        } catch (err) {
          console.error("Erro ao sintonizar via link de partilha:", err);
        }
      });
    }

    // 1. Carrega as Lives Ativas e os Posts normais misturados por algoritmo
    const qPosts = query(collection(db, "posts"), orderBy("criadoEm", "desc"));
    const qLives = query(collection(db, "lives_activas"), where("status", "==", "online"));
    const qBatalhasArena = query(collection(db, "batalhasAtivas"), where("fase", "!=", "FIM"));

    let postsAtuais = [];
    let livesAtuais = [];
    let batalhasAtuais = [];

    const atualizarFeedMisturado = () => {
      // Injeta as batalhas PK em direto no algoritmo unificado do feed principal
      const feedMisturado = [...batalhasAtuais, ...livesAtuais, ...postsAtuais];
      setPosts(feedMisturado);
    };

    const unsubscribePosts = onSnapshot(qPosts, (snapshot) => {
      postsAtuais = snapshot.docs.map(d => ({ id: d.id, tipoElemento: 'post', ...d.data() }));
      atualizarFeedMisturado();
    });

    const unsubscribeLives = onSnapshot(qLives, (snapshot) => {
      const meuUidLogado = auth.currentUser?.uid;
      livesAtuais = snapshot.docs
        .filter(doc => doc.id !== meuUidLogado)
        .map(d => ({ id: d.id, tipoElemento: 'live', ...d.data() }));
      atualizarFeedMisturado();
    });

    const unsubscribeBatalhasArena = onSnapshot(qBatalhasArena, (snapshot) => {
      const meuUidLogado = auth.currentUser?.uid;
      batalhasAtuais = snapshot.docs
        .filter(doc => {
          const dados = doc.data();
          return dados?.idA !== meuUidLogado && dados?.idB !== meuUidLogado;
        })
        .map(d => ({ 
          id: d.id, 
          tipoElemento: 'batalha', 
          isBatalha: true,
          ...d.data() 
        }));
      atualizarFeedMisturado();
    });

    // Listener para abrir posts específicos ao clicar nas notificações
    const handleAbrirPost = async (e) => {
      const idPost = e.detail.postId;
      const tipoNotif = e.detail.tipo;
      if (!idPost) return;

      const postSnap = await getDoc(doc(db, "posts", idPost));
      if (postSnap.exists()) {
        const postData = { id: idPost, ...postSnap.data() };
        setPosts(prev => [postData, ...prev.filter(p => p.id !== idPost)]);
        setIdPostAtivo(postData);
        setEcraAtivo('feed');

        if (tipoNotif === 'comentario') {
          setMostrarComentarios(true);
        } else {
          setMostrarComentarios(false);
        }
      }
    };

    window.addEventListener('abrirPostEspecifico', handleAbrirPost);

    window.addEventListener('abrirBancadaDireto', (e) => {
      const idSala = e.detail?.salaId;
      if (!idSala) return;

      import('firebase/firestore').then(async ({ doc: fDoc, getDoc: fGetDoc }) => {
        const snap = await fGetDoc(fDoc(db, "salas_bancada", idSala));
        if (snap.exists()) {
          // 🚨 BLINDAGEM ANTI-PISCAR: Cria um muro preto instantâneo no ecrã para trancar a transição
          const cortinaDeTransicao = document.createElement('div');
          cortinaDeTransicao.style.position = 'fixed';
          cortinaDeTransicao.style.inset = '0';
          cortinaDeTransicao.style.backgroundColor = '#020406';
          cortinaDeTransicao.style.zIndex = '99999999';
          cortinaDeTransicao.id = 'cortina-blindada-pwa';
          document.body.appendChild(cortinaDeTransicao);

          // Tranca de segurança universal via memória global da janela
          window.idDataSalaDestinoGlobal = idSala;
          setEcraAtivo('bancada');

          // Remove a cortina suavemente após a sala estar montada no DOM
          setTimeout(() => {
            document.getElementById('cortina-blindada-pwa')?.remove();
          }, 400);

        } else {
          alert("Esta bancada já terminou! 🏟️❌");
        }
      }).catch(err => console.error(err));
    });

    // ABRIR UMA BATALHA A PARTIR DE UMA NOTIFICAÇÃO (Arena PK ou Champions PK).
    const handleAbrirBatalha = (e) => {
      const idBat = e.detail?.batalhaId;
      const tipo = e.detail?.tipo;
      if (!idBat) return;

      if (tipo === 'champions_pk') {
        window.location.href = `/?champions&batalha=${idBat}`;
        return;
      }

      setDadosUtilizador({ id: idBat, uid: idBat, batalhaId: idBat });
      setEcraAtivo('arena_pk');
    };
    window.addEventListener('abrirBatalha', handleAbrirBatalha);

    return () => {
      unsubscribePosts();
      unsubscribeLives();
      unsubscribeBatalhasArena();
      window.removeEventListener('abrirPostEspecifico', handleAbrirPost);
      window.removeEventListener('abrirBancadaDireto', () => {});
      window.removeEventListener('abrirBatalha', handleAbrirBatalha);
    };
  }, []);

useEffect(() => {
    const obterUtilizadores = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "utilizadores"));
        const lista = querySnapshot.docs.map(doc => ({
          uid: doc.id,
          ...doc.data()
        }));
        setUtilizadores(lista);
      } catch (e) { console.error("Erro ao carregar craques:", e); }
    };
    obterUtilizadores();
  }, []);

  useEffect(() => {
    const meuId = auth.currentUser?.uid;
    if (!meuId) return;

    const q = query(
      collection(db, "utilizadores", meuId, "notificacoes"),
      where("lida", "==", "false"),
      limit(1)
    );

    const unsub = onSnapshot(q, (snap) => {
      setNotificacaoAtiva(!snap.empty);
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!idPostAtivo?.id) {
      setListaComentarios([]);
      return;
    }
    const q = query(collection(db, "posts", idPostAtivo.id, "comentarios"), orderBy("criadoEm", "asc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setListaComentarios(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, [idPostAtivo?.id]);

  // LEITOR DE MENSAGENS EM TEMPO REAL (BALNEÁRIO PRIVATE CHAT CORRIGIDO)
  useEffect(() => {
    if (!conversaAtiva) return;
    const meuId = auth.currentUser?.uid;
    const idDeles = conversaAtiva.uid;
    if (!meuId || !idDeles) return;

    const idChat = meuId < idDeles ? `${meuId}_${idDeles}` : `${idDeles}_${meuId}`;

    // Escuta direta e limpa da coleção (Bypassa a exigência de índices na nuvem)
    const q = collection(db, "chats", idChat, "mensagens");
    
    const unsubscribe = onSnapshot(q, (snap) => {
      const listaDocs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Ordena com total segurança no telemóvel, tratando timestamps locais
      listaDocs.sort((a, b) => {
        const tA = a.criadoEm?.toMillis ? a.criadoEm.toMillis() : (a.criadoEm?.seconds ? a.criadoEm.seconds * 1000 : Date.now());
        const tB = b.criadoEm?.toMillis ? b.criadoEm.toMillis() : (b.criadoEm?.seconds ? b.criadoEm.seconds * 1000 : Date.now());
        return tA - tB;
      });
      
      setMensagensChat(listaDocs);
    }, (error) => {
      console.error("Erro na antena do chat privado:", error);
    });

    return () => unsubscribe();
  }, [conversaAtiva]);

const tPresenteAlertas = {
  pt: {
    entrar: "Entra na tua conta para enviares presentes! ⚽",
    auto: "Não podes enviar presentes para as tuas próprias publicações! ⚽❌",
    saldo: "Saldo insuficiente! ⚽",
    notif: "enviou-te um presente"
  },
  en: {
    entrar: "Log in to your account to send gifts! ⚽",
    auto: "You cannot send gifts to your own posts! ⚽❌",
    saldo: "Insufficient balance! ⚽",
    notif: "sent you a gift"
  },
  es: {
    entrar: "¡Inicia sesión en tu cuenta para enviar regalos! ⚽",
    auto: "¡No puedes enviar regalos a tus propias publicaciones! ⚽❌",
    saldo: "¡Saldo insuficiente! ⚽",
    notif: "te envió un regalo"
  },
  fr: {
    entrar: "Connectez-vous à votre compte pour envoyer des cadeaux ! ⚽",
    auto: "Vous ne pouvez pas envoyer de cadeaux à vos propres publications ! ⚽❌",
    saldo: "Solde insuffisant ! ⚽",
    notif: "t'a envoyé un cadeau"
  }
};

  const dispararPresente = async (idDoItem, videoUrl, precoBolas, post, nomePresente) => {
  const idiomaLocal = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
  const tL = tLikeDicionario[idiomaLocal] || tLikeDicionario.en;

  // Um visitante sem sessão consegue chegar ao Feed por um link "?postId=".
  if (!auth.currentUser?.uid) {
    alert(tP.entrar);
    return;
  }

    // Define o alvo (quem recebe o presente no Feed) de forma infalível
  const idAlvo = post?.userId || post?.uid || idPostAtivo?.userId || idPostAtivo?.uid || post?.utilizadorId;
  const postIdAlvo = post?.id || post?._id || idPostAtivo?.id || idPostAtivo?._id || "";

  // BLOQUEIO SEGURO DE AUTO-PRESENTE: Ninguém pode enviar presentes a si próprio!
  if (idAlvo === auth.currentUser?.uid) {
    alert(tP.auto);
    return;
  }

  try {
    const isVideo3DPremium = videoUrl && String(videoUrl).toLowerCase().includes('.webm');

    // Inicializa o motor com a região europeia correta exigida pela Google
    const { getFunctions, httpsCallable } = await import('firebase/functions');

// EXTRAÇÃO SEGURA: Vamos buscar o app diretamente à instância de functions do teu projeto
const meuAppBase = functions.app; 

// Inicializa a região europeia com o objeto extraído corretamente
const funcsEuropa = getFunctions(meuAppBase, 'europe-west1');

const nomeDaFuncao = isVideo3DPremium ? 'processarPresenteVideoFeedSeguro' : 'processarStickerFeedSeguro';
const chamarFuncaoSegura = httpsCallable(funcsEuropa, nomeDaFuncao);

        // Envia os dados corretos para o servidor independente (Incluindo o link do vídeo para o ecrã ler)
    const respostaServidor = await chamarFuncaoSegura({
      idDoItem,
      precoBolas,
      idAlvo,
      nomePresente: nomePresente || "Sticker",
      videoUrl: videoUrl || "" // 🟢 LINHA REPOSTA PARA O TEU ECRÃ ATIVAR A ANIMAÇÃO
    });

        // Se o servidor aprovou a transação com sucesso absoluto:
            // Se o servidor aprovou a transação com sucesso absoluto:
    if (respostaServidor.data?.sucesso || respostaServidor.data?.suceso) {
      
      // SINAL PARA O FEED: Garante que passa o url do vídeo e o ID correto capturado
      setPresenteAtivo({ url: videoUrl, postId: postIdAlvo || idPostAtivo?.id });
      
      // ⏱️ RELÓGIO DE SEGURANÇA: Só remove automaticamente se FOR STICKER.
      // Se for vídeo, deixa que o 'onEnded' do JSX feche o presente quando o filme acabar!
      if (!isVideo3DPremium) {
        setTimeout(() => {
          setPresenteAtivo(null);
        }, 3000); // 3 segundos é o tempo ideal para exibir um sticker estático
      }

      // 🚨 TRANCA INTELIGENTE DO SOM BOMBA PREMIUM
      if (!isVideo3DPremium) {
        try {
          const somBomba = new Audio("/sounds/bomba-explosao.mp3");
          somBomba.volume = 1.0;
          somBomba.play().catch(err => console.log("Permissão de áudio pendente:", err));
        } catch (errSom) { console.error("Erro ao tocar áudio da bomba:", errSom); }
      }

      // GRAVA A NOTIFICAÇÃO ENRIQUECIDA NO SININHO DO DONO DO POST
      const donoDoPostId = post?.userId || post?.utilizadorId || idPostAtivo?.userId;
      if (donoDoPostId && donoDoPostId !== auth.currentUser?.uid) {
        
        // 🛡️ CORREÇÃO E BLINDAGEM DO TRADUTOR LOCAL:
        const lgNotif = (navigator.language || navigator.userLanguage || "pt").toLowerCase().substring(0, 2);
        const textoNotifFinal = lgNotif === "pt" ? "enviou-te um presente" :
                                lgNotif === "es" ? "te envió un regalo" :
                                lgNotif === "fr" ? "t'a envoyé un cadeau" : "sent you a gift";

        await addDoc(collection(db, "utilizadores", donoDoPostId, "notificacoes"), {
          tipo: 'presente',
          lida: "false",
          remetenteId: auth.currentUser?.uid,
          remetenteNome: auth.currentUser?.displayName || "Alguém",
          timestamp: serverTimestamp(),
          dados: {
            tipo: 'presente',
            lida: "false",
            postId: postIdAlvo,
            remetenteId: auth.currentUser?.uid,
            remetenteNome: auth.currentUser?.displayName || "Alguém",
            textoCustom: `: ${textoNotifFinal} [${nomePresente || "Sticker"}]! 🎁⚽`,
            videoUrl: videoUrl || "",
            nomeSticker: nomePresente || "Sticker"
          }
        });
      }
    }
  } catch (erroServidor) {
    console.error("Erro ao processar presente no servidor:", erroServidor);
    if (erroServidor.message?.includes("SALDO_INSUFICIENTE") || erroServidor.code === "failed-precondition") {
      alert("Saldo insuficiente de Bolas!");
    } else {
      alert("Erro ao enviar o presente. Verifica o teu saldo e tenta novamente! ⚽");
    }
  }
};

// FUNÇÃO DE AJUSTE DE STICKER
const fecharPresente = () => setPresenteAtivo(null);

// SENSOR DE DADOS DO UTILIZADOR: corre UMA única vez
useEffect(() => {
  let desligarSaldo = null;

  const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
    if (!user) return;

    try {
      // COFRE: Cria ou garante a ficha salvaguardando a integridade das BOLAS.
      const { dados } = await garantirFichaUtilizador(user);
      setDadosUtilizador((atual) => atual || dados);
    } catch (errFicha) {
      console.error("Nao foi possivel garantir a ficha do utilizador:", errFicha);
    }

        // SALDO EM TEMPO REAL: substitui o `getDoc` de leitura unica. Qualquer
      // alteracao feita na consola do Firebase aparece no ecra sem recarregar.
      if (typeof desligarSaldo === 'function') desligarSaldo();
      desligarSaldo = observarSaldo(user.uid, ({ bolas, dados: fresco }) => {
        setSaldoBolas(bolas); // Mantém o feed focado apenas nas BOLAS
        setDadosUtilizador((atual) => {
          // Só se atualiza o perfil base quando nenhum alvo (live / perfil de
          // outro craque) estiver aberto por cima.
          if (atual && atual.uid && atual.uid !== user.uid) return atual;
          return { ...(atual || {}), ...fresco };
        });
      });

    // ESCUTADOR EM TEMPO REAL: Se bloqueares alguém agora, o Feed reage na hora
      onSnapshot(collection(db, "utilizadores", user.uid, "bloqueados"), (snapshot) => {
        const idsBloqueados = snapshot.docs.map(d => d.id);
        setMeusBloqueados(idsBloqueados);
      });

      // ESCUTADOR DE QUEM ME BLOQUEOU (BLOQUEIO MÚTUO SEGURO)
      onSnapshot(collectionGroup(db, "bloqueados"), (snapB) => {
        const idsQueMeBloquearam = [];
        snapB.forEach(d => {
          if (d.id === user.uid) idsQueMeBloquearam.push(d.ref.parent.parent.id);
        });
        setQuemMeBloqueou(idsQueMeBloquearam);
      });
    });

    // Eventos Globais de Atalho para o Feed e Menus
    const handleAbrirSaldo = () => setMostrarMenuSaldo(true);
    const handleAbrirComentariosPerfil = (e) => {
      setIdPostAtivo(e.detail);
      setMostrarComentarios(true);
    };

    window.addEventListener('abrirMenuSaldo', handleAbrirSaldo);
    window.addEventListener('abrirComentariosPerfil', handleAbrirComentariosPerfil);
    window.addEventListener('mudarEcraGlobal', (e) => { if (e.detail) setEcraAtivo(e.detail); });

    return () => {
      unsubscribeAuth();
      if (typeof desligarSaldo === 'function') desligarSaldo();
      window.removeEventListener('abrirMenuSaldo', handleAbrirSaldo);
      window.removeEventListener('abrirComentariosPerfil', handleAbrirComentariosPerfil);
      window.removeEventListener('mudarEcraGlobal', () => {});
    };
  }, []);

    // --- FUNÇÕES DE AÇÃO DO FEED E UPLOAD ---
  const selecionarArquivoParaPost = (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;
  // Correção cirúrgica com o nome do teu estado oficial e o primeiro ficheiro
  setArquivoParaPostar(files[0]);
  setLegenda('');
};

  // --- FUNÇÕES DE AÇÃO DO BALNEÁRIO (CHAT PRIVADO) ---
  const enviarMensagem = async () => {
    if (mensagemTexto.trim() === "" || !conversaAtiva) return;
    try {
      const meuId = auth.currentUser?.uid;
      const idDeles = conversaAtiva.uid;

      // ID Único da conversa
      const idChat = meuId < idDeles ? `${meuId}_${idDeles}` : `${idDeles}_${meuId}`;

      await addDoc(collection(db, "chats", idChat, "mensagens"), {
        texto: mensagemTexto,
        enviadoPor: meuId,
        criadoEm: serverTimestamp()
      });

      // Notifica o destinatário agora que a mensagem foi gravada
      enviarNotificacao(idDeles, meuId, auth.currentUser.displayName || "Um craque", "chat");

      setMensagemTexto(""); // Limpa o campo
    } catch (e) { 
      console.error("Erro ao enviar bola:", e); 
    }
  };

      const confirmarPostagem = async () => {
    if (!arquivoParaPostar) return;
    if (carregando || window.travarCliqueUploadFeed) return;
    
    // Tranca eletrónica imediata contra cliques duplos mundiais
    window.travarCliqueUploadFeed = true;
    setCarregando(true);
    
    try {
      const { ref: fRef, uploadBytesResumable, getDownloadURL } = await import('firebase/storage');
      const { collection: fColl, addDoc: fAddDoc, serverTimestamp: fTime } = await import('firebase/firestore');
      
      const user = auth.currentUser;
      
      // Deteta se é vídeo ou foto diretamente pelo tipo de ficheiro real do telemóvel
      const tipoReal = arquivoParaPostar.type?.startsWith('video') ? 'video' : 'foto';
      const fileRef = fRef(storage, `${tipoReal}/${Date.now()}_${user.uid}`);
      
      const uploadTask = uploadBytesResumable(fileRef, arquivoParaPostar);
      
      uploadTask.on('state_changed', 
        (snapshot) => {
          const progresso = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          
          // Deteção universal de idioma limpa e infalível
          const lg = (navigator.language || navigator.userLanguage || "pt").toLowerCase().substring(0, 2);
          if (lg === "pt") setLegenda(`A carregar... ${progresso}%`);
          else if (lg === "es") setLegenda(`Cargando... ${progresso}%`);
          else if (lg === "fr") setLegenda(`Chargement... ${progresso}%`);
          else setLegenda(`Uploading... ${progresso}%`);
        }, 
        (error) => {
          console.error("Erro no upload mundial:", error);
          window.travarCliqueUploadFeed = false;
          setCarregando(false);
          setLegenda('');
        }, 
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          
          // Limpa o contador de texto se o utilizador não escreveu legenda
          const legendaLimpa = (legenda.startsWith('A carregar') || legenda.startsWith('Upload') || legenda.startsWith('Cargando') || legenda.startsWith('Chargement')) ? '' : legenda;

          await fAddDoc(fColl(db, "posts"), {
            url: url,
            tipo: tipoReal,
            userId: user.uid,
            userName: user.displayName || "Utilizador",
            userFoto: user.photoURL || "",
            legenda: legendaLimpa,
            likes: 0,
            criadoEm: fTime()
          });
          
          window.travarCliqueUploadFeed = false;
          setArquivoParaPostar(null);
          setLegenda('');
          setCarregando(false);
        }
      );
    } catch (e) {
      console.error("Erro geral no upload:", e);
      window.travarCliqueUploadFeed = false;
      setCarregando(false);
      setLegenda('');
    }
  };

  const tLikeDicionario = {
  pt: {
    auto: "Não podes dar like nas tuas próprias publicações! ❤️❌",
    video: "gostou do teu vídeo! ❤️",
    foto: "gostou da tua foto! ❤️",
    fallbackNome: "Um craque"
  },
  en: {
    auto: "You cannot like your own posts! ❤️❌",
    video: "liked your video! ❤️",
    foto: "liked your photo! ❤️",
    fallbackNome: "A player"
  },
  es: {
    auto: "¡No puedes dar me gusta a tus propias publicaciones! ❤️❌",
    video: "le gustó tu video! ❤️",
    foto: "le gustó tu foto! ❤️",
    fallbackNome: "Un crack"
  },
  fr: {
    auto: "Vous ne pouvez pas aimer vos propres publications ! ❤️❌",
    video: "a aimé voutre vidéo ! ❤️",
    foto: "a aimé votre photo ! ❤️",
    fallbackNome: "Un crack"
  }
};

const darLike = async (postId, likesAtuais, quemDeuLikeIgnorado, postOwnerId) => {
  if (!postId) return null;
  const meuId = auth.currentUser?.uid;
  if (!meuId) return null;

  const idiomaLocal = (navigator.language || navigator.userLanguage).toLowerCase().split('-');
  const tL = tLikeDicionario[idiomaLocal] || tLikeDicionario.en;

  // 1. BLOQUEIO DE AUTO-GOSTO LOCALIZADO
  if (postOwnerId === meuId) {
    alert(tL.auto);
    return null;
  }

  try {
    const postRef = doc(db, "posts", postId);
    const postSnap = await getDoc(postRef);

    if (postSnap.exists()) {
      const data = postSnap.data();
      const curtidasRicas = data.curtidasRicas || [];
      const jaDeuLike = curtidasRicas.some(c => c.userId === meuId);

      let novaListaRica = [];
      if (jaDeuLike) {
        novaListaRica = curtidasRicas.filter(c => c.userId !== meuId);
      } else {
        novaListaRica = [
          ...curtidasRicas,
          {
            userId: meuId,
            userName: auth.currentUser?.displayName || tL.fallbackNome,
            userFoto: auth.currentUser?.photoURL || "https://gravatar.com"
          }
        ];
      }

      const novoTotal = novaListaRica.length;

      // Atualiza o documento no Firestore
      await updateDoc(postRef, {
        likes: novoTotal,
        curtidasRicas: novaListaRica
      });

      // Notificação de Like Multilíngue
      if (novoTotal > (likesAtuais || 0)) {
        const textoLike = data?.tipo === 'video' ? tL.video : tL.foto;
        enviarNotificacao(postOwnerId, meuId, auth.currentUser.displayName || tL.fallbackNome, "like", { postId: postId, textoCustom: textoLike });
      }

      return { novoTotal, novaListaRica };
    }
    return null;
  } catch (e) { 
    console.error("Erro no Like Profissional:", e); 
    return null;
  }
};

    // =========================================================================
// 📋 DICIONÁRIO MULTILÍNGUE DE SEGUIDORES (PADRÃO INTERNACIONAL)
// =========================================================================
const tSeguirDicionario = {
  pt: {
    sucesso: "Agora segues @",
    notif: " começou a seguir-te! ⚽🏃‍♂️",
    fallbackNome: "Um adepto"
  },
  en: {
    sucesso: "You are now following @",
    notif: " started following you! ⚽🏃‍♂️",
    fallbackNome: "A fan"
  },
  es: {
    sucesso: "¡Ahora sigues a @",
    notif: " ¡comenzó a seguirte! ⚽🏃‍♂️",
    fallbackNome: "Un aficionado"
  },
  fr: {
    sucesso: "Vous suivez maintenant @",
    notif: " a commencé à vous suivre ! ⚽🏃‍♂️",
    fallbackNome: "Un supporter"
  }
};

// =========================================================================
// 🚀 GATILHO UNIVERSAL DE SEGUIR UTILIZADOR (SÍNCRONO E UNIFICADO)
// =========================================================================
const seguirPeloFeed = async (idAlvo, nomeAlvo) => {
  const meuId = auth.currentUser?.uid;
  if (!meuId || meuId === idAlvo) return;

  // Extração cirúrgica da sigla de idioma limpa ('pt', 'en', 'es', 'fr')
  const idiomaDispositivo = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
  const tS = tSeguirDicionario[idiomaDispositivo] || tSeguirDicionario.en;

  try {
    const { serverTimestamp, doc, setDoc, addDoc, collection, updateDoc, increment } = await import('firebase/firestore');
    
    // 1. Grava na lista de quem TU estás a seguir (Subcoleção 'seguindo')
    await setDoc(doc(db, "utilizadores", meuId, "seguindo", idAlvo), {
      nome: nomeAlvo,
      data: serverTimestamp()
    });

    // 2. Incrementa o contador 'seguindoCount' no teu próprio documento de perfil
    await updateDoc(doc(db, "utilizadores", meuId), {
      seguindoCount: increment(1)
    }).catch(() => {});

    // 3. Grava na lista de quem me segue no ALVO (Subcoleção universal 'seguidores' - SEM INGLÊS)
    await setDoc(doc(db, "utilizadores", idAlvo, "seguidores", meuId), {
      nome: auth.currentUser.displayName || "Craque",
      fotoUrl: auth.currentUser.photoURL || "",
      data: serverTimestamp()
    });

    // 4. Incrementa o contador 'seguidoresCount' no documento do criador (Alvo) de forma automática
    await updateDoc(doc(db, "utilizadores", idAlvo), {
      seguidoresCount: increment(1)
    }).catch(() => {});

    // 5. GRAVAÇÃO DIRETA E RICA NO SININHO DE QUEM RECEBEU O FOLLOW MULTILÍNGUE
    await addDoc(collection(db, "utilizadores", idAlvo, "notificacoes"), {
      tipo: 'seguir',
      lida: "false",
      remetenteId: meuId,
      remetenteNome: auth.currentUser?.displayName || tS.fallbackNome,
      timestamp: serverTimestamp(),
      dados: {
        tipo: 'seguir',
        lida: "false",
        remetenteId: meuId,
        remetenteNome: auth.currentUser?.displayName || tS.fallbackNome,
        textoCustom: `${tS.notif}`
      }
    });

    // 6. Força o ponto vermelho do sininho a acender no ecrã do alvo
    if (idAlvo === auth.currentUser?.uid && typeof setNotificacaoAtiva === 'function') {
      setNotificacaoAtiva(true);
    }

    // Alerta limpo e reativo na língua oficial do utilizador
    alert(`${tS.sucesso}${nomeAlvo} ! ⚽`);
  } catch (e) { 
    console.error("Erro crítico ao processar rotina de follow:", e); 
  }
};

    const tComentarioDicionario = {
  pt: {
    resposta: " respondeu ao teu comentário! 💬",
    video: "comentou o teu vídeo! ⚽",
    foto: "comentou a tua foto! 📸",
    fallbackNome: "Craque"
  },
  en: {
    resposta: " replied to your comment! 💬",
    video: "commented on your video! ⚽",
    foto: "commented on your photo! 📸",
    fallbackNome: "Player"
  },
  es: {
    resposta: " ¡respondió a tu comentario! 💬",
    video: "¡comentó tu video! ⚽",
    foto: "¡comentó tu foto! 📸",
    fallbackNome: "Crack"
  },
  fr: {
    resposta: " a répondu à votre commentaire ! 💬",
    video: "a commenté votre vidéo ! ⚽",
    foto: "a commenté votre photo ! 📸",
    fallbackNome: "Crack"
  }
};

const enviarComentario = async () => {
  if (novoComentario.trim() === "" || !idPostAtivo?.id) return;

  //  Forma correta e segura:
const idiomaLocal = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
const tL = tLikeDicionario[idiomaLocal] || tLikeDicionario.en;

  try {
    const { collection, addDoc, serverTimestamp, doc, updateDoc, increment } = await import('firebase/firestore');
    
    if (comentarioAInteragir) {
      // 1. GRAVA COMO RESPOSTA RECUADA DENTRO DO COMENTÁRIO PAI (Estilo Facebook/TikTok)
      await addDoc(collection(db, "posts", idPostAtivo.id, "comentarios", comentarioAInteragir.id, "respostas"), {
        texto: novoComentario,
        userName: auth.currentUser?.displayName || tC.fallbackNome,
        userId: auth.currentUser?.uid,
        userFoto: auth.currentUser?.photoURL || dadosUtilizador?.fotoUrl || "https://gravatar.com",
        criadoEm: serverTimestamp()
      });
    } else {
      // 1. GRAVA COMO COMENTÁRIO PRINCIPAL REGULAR
      await addDoc(collection(db, "posts", idPostAtivo.id, "comentarios"), {
        texto: novoComentario,
        userName: auth.currentUser?.displayName || tC.fallbackNome,
        userId: auth.currentUser?.uid,
        userFoto: auth.currentUser?.photoURL || dadosUtilizador?.fotoUrl || "https://gravatar.com",
        criadoEm: serverTimestamp()
      });
    }

    // 2. Sobe o número no contador do post
    await updateDoc(doc(db, "posts", idPostAtivo.id), {
      totalComentarios: increment(1)
    });

    // DISPARAR NOTIFICAÇÕES LOCALIZADAS (COMENTÁRIO OU RESPOSTA)
    if (comentarioAInteragir) {
      const donoDoComentarioId = comentarioAInteragir.userId || comentarioAInteragir.utilizadorId;
      
      if (donoDoComentarioId && donoDoComentarioId !== auth.currentUser?.uid) {
        await addDoc(collection(db, "utilizadores", donoDoComentarioId, "notificacoes"), {
          tipo: 'comentario',
          lida: "false",
          remetenteId: auth.currentUser?.uid,
          remetenteNome: auth.currentUser?.displayName || tC.fallbackNome,
          timestamp: serverTimestamp(),
          dados: {
            tipo: 'comentario',
            lida: "false",
            postId: idPostAtivo.id,
            remetenteId: auth.currentUser?.uid,
            remetenteNome: auth.currentUser?.displayName || tC.fallbackNome,
            textoCustom: `${tC.resposta}`
          }
        });
      }
    } else {
      // Se for um comentário normal na raiz, notifica o dono do post
      if (idPostAtivo.userId !== auth.currentUser?.uid) {
        const textoNotif = idPostAtivo.tipo === 'video' ? tC.video : tC.foto;
        
        enviarNotificacao(
          idPostAtivo.userId, 
          auth.currentUser?.uid, 
          auth.currentUser?.displayName || tC.fallbackNome, 
          "comentario",
          { postId: idPostAtivo.id, textoCustom: textoNotif }
        );
      }
    }

    setNovoComentario(""); 
  } catch (e) { 
    console.error("Erro ao enviar comentário:", e); 
  }
};

  // =========================================================================
// 📋 DICIONÁRIO INTERNACIONAl DE PARTILHA PREMIUM (GAVETA DO ESTÁDIO)
// =========================================================================
const tPartilhaDicionario = {
  pt: {
    notif: " partilhou uma publicação contigo! 🏟️⚽",
    sucessoPrivado: "Publicação partilhada em privado com sucesso! ⚽🚀",
    erroPartilha: "Erro ao partilhar.",
    tituloShare: "Vê este craque no GAME FUT LIVE! ⚽",
    linkCopiado: "Link copiado para o estádio! ⚽",
    fallbackNome: "Um adepto"
  },
  en: {
    notif: " shared a post with you! 🏟️⚽",
    sucessoPrivado: "Post successfully shared in private! ⚽🚀",
    erroPartilha: "Error sharing.",
    tituloShare: "Check out this player on GAME FUT LIVE! ⚽",
    linkCopiado: "Link copied to the stadium! ⚽",
    fallbackNome: "A fan"
  },
  es: {
    notif: " ¡compartió una publicação contigo! 🏟️⚽",
    sucessoPrivado: "¡Publicación compartida en privado con éxito! ⚽🚀",
    erroPartilha: "Error al compartir.",
    tituloShare: "¡Mira a este crack en GAME FUT LIVE! ⚽",
    linkCopiado: "¡Enlace copiado al estadio! ⚽",
    fallbackNome: "Un aficionado"
  },
  fr: {
    notif: " a partagé une publication avec toi ! 🏟️⚽",
    sucessoPrivado: "Publication partagée en privé avec succès ! ⚽🚀",
    erroPartilha: "Erreur lors du partage.",
    tituloShare: "Regarde ce crack sur GAME FUT LIVE ! ⚽",
    linkCopiado: "Lien copié dans le stade ! ⚽",
    fallbackNome: "Un supporter"
  }
};

// =========================================================================
// 🚀 GATILHO DE PARTILHA PRIVADA EM SEGUNDO PLANO MULTILÍNGUE
// =========================================================================
const abrirMenuPartilhaInterna = async (post) => {
  // Captura e normaliza o idioma do dispositivo imediatamente no arranque do clique
  const idiomaDispositivo = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
  const tP = tPartilhaDicionario[idiomaDispositivo] || tPartilhaDicionario.en;

  setPostAPartilharInterno(post);
  setMostrarListaPartilha(true);
  
  try {
    const { collection, getDocs, limit, query } = await import('firebase/firestore');
    const q = query(collection(db, "utilizadores"), limit(20));
    const snap = await getDocs(q);
    const meuIdAtual = auth.currentUser?.uid;
    
    const listaFinal = snap.docs.map(docSnap => ({ 
      id: docSnap.id, 
      ...docSnap.data() 
    })).filter(u => u.id !== meuIdAtual);
    
    setUtilizadoresApp(listaFinal);
  } catch (e) { 
    console.error("Erro ao listar craques para partilha:", e); 
  }
};

const dispararPartilhaPrivada = async (idAlvo) => {
  if (!postAPartilharInterno || !idAlvo) return;
  const idiomaLocal = (navigator.language || navigator.userLanguage).toLowerCase().split('-');
  const tP = tPartilhaDicionario[idiomaLocal] || tPartilhaDicionario.en;

  try {
    const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
    
    // Grava diretamente no sininho de notificações do utilizador escolhido
    await addDoc(collection(db, "utilizadores", idAlvo, "notificacoes"), {
      tipo: 'post_partilhado', 
      lida: "false",
      remetenteId: auth.currentUser?.uid,
      remetenteNome: auth.currentUser?.displayName || tP.fallbackNome,
      timestamp: serverTimestamp(),
      dados: {
        tipo: 'post_partilhado',
        lida: "false",
        remetenteId: auth.currentUser?.uid,
        remetenteNome: auth.currentUser?.displayName || tP.fallbackNome,
        postId: postAPartilharInterno.id,
        textoCustom: tP.notif
      }
    });

    alert(tP.sucessoPrivado);
    setMostrarListaPartilha(false);
  } catch (e) { 
    console.error("Erro ao enviar partilha privada:", e); 
    alert(tP.erroPartilha);
  }
};

const partilharPost = async (post) => {
  const idiomaLocal = (navigator.language || navigator.userLanguage).toLowerCase().split('-');
  const tP = tPartilhaDicionario[idiomaLocal] || tPartilhaDicionario.en;
  const linkReal = window.location.origin + "/?post=" + post.id; 

  if (navigator.share) {
    try {
      await navigator.share({
        title: tP.tituloShare,
        url: linkReal,
      });
    } catch (e) { 
      console.log("Partilha cancelada"); 
    }
  } else {
    navigator.clipboard.writeText(linkReal);
    alert(tP.linkCopiado);
  }
};

  // --- FILTROS DE PUBLICAÇÃO DO FEED ---
  const postsDaAba = (abaAtual === 'video_unico' && idPostAtivo?.id) ? [idPostAtivo] : posts;
  const postAtual = postsDaAba.length > 0 ? postsDaAba[0] : null;

  // --- ESCUTADOR EM TEMPO REAL DOS LIKES RICOS DO POST ATIVO ---
  useEffect(() => {
    if (!idPostAtivo?.id || !mostrarListaLikes) return;
    
    // Escuta a lista rica de curtidas diretamente do post ativo no Firestore
    const unsubLikes = onSnapshot(doc(db, "posts", idPostAtivo.id), (snap) => {
      if (snap.exists()) {
        setIdPostAtivo(prev => prev ? { ...prev, curtidasRicas: snap.data().curtidasRicas || [] } : null);
      }
    });
    return () => unsubLikes();
  }, [idPostAtivo?.id, mostrarListaLikes]);

    // =========================================================================
  //                         RENDERIZAÇÃO VISUAL (JSX)
  // =========================================================================
  return (
    /* `sem-feed` desliga o scroll-snap e o overflow quando o ecrã visível não é
       o feed. O Safari do iPhone promove um contentor com `overflow: scroll` +
       `scroll-snap-type` a camada própria e passa a desenhar os filhos
       `position: fixed` DENTRO dessa camada, na posição em que o feed estava
       antes do scroll — por isso o perfil abria fora do ecrã e só se via preto.
       Sem scroller composto, o `position: fixed` volta a ser relativo à janela. */
    <div className={`video-container${ecraAtivo === 'feed' ? '' : ' sem-feed'}`}>

        {/* LUPA DE PESQUISA NO TOPO - ALINHADA E COM SAFE AREA ANTI-CORTE */}
      {ecraAtivo === 'feed' && (
        <div 
          onClick={() => setEcraAtivo('pesquisa')}
          style={{
            position: 'fixed',
            top: 'calc(20px + env(safe-area-inset-top))', // Margem de segurança dinâmica mundial para notches
            right: '20px',
            zIndex: 1000,
            cursor: 'pointer',
            background: 'rgba(0,0,0,0.5)', // Escurecido ligeiramente para maior contraste sobre qualquer post
            padding: '10px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(57, 255, 20, 0.4)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.5)'
          }}
        >
          <Search size={22} color="#39FF14" />
        </div>
      )}

          {/* 🏟️ MENU DE ABAS ESTILO TIKTOK (TODOS / A SEGUIR) - CORREÇÃO DE LARGURA HORIZONTAL */}
          {ecraAtivo === 'feed' && (
        <div style={{
          position: 'fixed',
          top: 'calc(20px + env(safe-area-inset-top))',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000,
          display: 'flex',
          gap: '30px', 
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          padding: '8px 24px', 
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
          whiteSpace: 'nowrap' 
        }}>
          <span 
            onClick={() => setAbaFiltroTikTok('todos')}
            style={{
              color: abaFiltroTikTok === 'todos' ? '#39FF14' : '#888',
              fontSize: '13px', 
              fontWeight: '900',
              cursor: 'pointer',
              transition: 'all 0.2s',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              textShadow: abaFiltroTikTok === 'todos' ? '0 0 8px rgba(57,255,20,0.4)' : 'none',
              borderBottom: abaFiltroTikTok === 'todos' ? '2px solid #39FF14' : '2px solid transparent',
              paddingBottom: '2px',
              display: 'inline-block'
            }}
          >
            {abaFiltroTikTok === 'todos' ? "Todos" : "Todos"}
          </span>

          <span 
             onClick={() => setAbaFiltroTikTok('seguir')}
            style={{
              color: abaFiltroTikTok === 'seguir' ? '#39FF14' : '#888',
              fontSize: '13px',
              fontWeight: '900',
              cursor: 'pointer',
              transition: 'all 0.2s',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              textShadow: abaFiltroTikTok === 'seguir' ? '0 0 8px rgba(57,255,20,0.4)' : 'none',
              borderBottom: abaFiltroTikTok === 'seguir' ? '2px solid #39FF14' : '2px solid transparent',
              paddingBottom: '2px',
              display: 'inline-block'
            }}
          >
            A Seguir
          </span>
        </div>
      )}

    {/* Ecrã de Entrada para libertar o som - CENTRALIZADO E MULTILINGUE */}
      {!somAtivo && (
        <div style={{ 
          backgroundColor: '#000', 
          height: '100vh', 
          width: '100vw', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          alignItems: 'center', 
          color: 'white', 
          textAlign: 'center', 
          paddingTop: 'calc(env(safe-area-inset-top) + 20px)',
          paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)',
          paddingLeft: 'calc(env(safe-area-inset-left) + 20px)',
          paddingRight: 'calc(env(safe-area-inset-right) + 20px)',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          boxSizing: 'border-box'
        }}>
          <h1 style={{ color: '#39FF14', fontSize: '26px', fontWeight: '900', marginBottom: '20px' }}>
            {tEntrada.titulo}
          </h1>
          
          <div style={{ maxWidth: '320px', width: '100%', boxSizing: 'border-box' }}>
            <h2 style={{ color: '#ff4444', fontSize: '16px', fontWeight: 'bold', marginBottom: '15px' }}>
              {tEntrada.fase}
            </h2>
            
            <ul style={{ listStyle: 'none', padding: 0, fontSize: '13px', color: '#ccc', lineHeight: '1.8' }}>
              {tEntrada.regras.map((regra, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: regra }} />
              ))}
            </ul>

            <p style={{ color: '#39FF14', fontSize: '11px', marginTop: '20px', marginBottom: '30px' }}>
              {tEntrada.aceite}
            </p>

            <p 
  onClick={() => window.open('https://gamefutlive.com', '_blank')}
  style={{ color: '#666', cursor: 'pointer', marginTop: '10px', marginBottom: '20px', fontSize: '11px', textAlign: 'center', textDecoration: 'underline' }}
>
  Consultar Termos de Uso e Políticas do Estádio
</p>

            <button 
              onClick={() => setSomAtivo(true)} 
              style={{ 
                background: '#39FF14', color: 'black', padding: '18px 40px', 
                borderRadius: '15px', border: 'none', fontWeight: '900', fontSize: '16px',
                boxShadow: '0 0 20px rgba(57, 255, 20, 0.5)', cursor: 'pointer',
                width: '100%',
                boxSizing: 'border-box'
              }}
            >
              {tEntrada.botao}
            </button>
          </div>
        </div>
      )}

      {/* {/* SE O ECRÃ FOR FEED, MOSTRA OS VÍDEOS, FOTOS E LIVES MIXADAS */}
      {ecraAtivo === 'feed' ? (
        postsFiltradosTikTok.map((post) => {
          // Extrai o ID do dono, seja um post ou uma live ativa
          const idDonoElemento = post.tipoElemento === 'live' ? post.uid : post.userId;

          // FILTRO DE BLOQUEIO SEGURO
          if (meusBloqueados.includes(idDonoElemento) || quemMeBloqueou.includes(idDonoElemento)) {
            return null;
          }

          // 🛡️ COMPETIÇÕES RETIRADAS DO FEED: SE FOR UMA BATALHA ATIVA DA ARENA PK, IGNORA O DESENHO
          if (post.tipoElemento === 'batalha') {
            return null;
          }

        // 🛡️ COMPETIÇÕES RETIRADAS DO FEED: SE FOR UMA LIVE EM DIRETO, IGNORA O DESENHO
          if (post.tipoElemento === 'live') {
            return null;
          }

          // CASO CONTRÁRIO, CONTINUA A RENDERIZAR OS VÍDEOS E FOTOS NATIVOS DO FEED
        const videoRef = (el) => {
  if (!el) return;
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.play().catch(() => {});
        el.muted = !somAtivo;
        
        // 🔊 Ativa o som por 1 segundo ao fazer scroll
        setMostrarAlertaSom(true);
        if (window.timerAlertaSomFeed) clearTimeout(window.timerAlertaSomFeed);
        window.timerAlertaSomFeed = setTimeout(() => {
          setMostrarAlertaSom(false);
        }, 1000);
      } else {
        el.pause();
      }
    },
    { threshold: 0.8 }
  );
  observer.observe(el);
};

          return (
            <div key={post.id} className="content-box">
              {post.tipo === 'video' ? (
                !presenteAtivo ? (
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <video
                    src={post.url}
                    className="main-video"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    loop
                    autoPlay
                    muted={!somAtivoGlobal}
                    playsInline
                    ref={(el) => {
                      if (!el) return;
                      // Criar um detetor de presença para calar o vídeo ao fazer scroll
                      if (!el.dataset.observerAtivo) {
                        el.dataset.observerAtivo = "true";
                        const observer = new IntersectionObserver((entries) => {
                          entries.forEach(entry => {
                            if (!entry.isIntersecting) {
                              el.pause(); // Cassa o som e o movimento se sair do ecrã
                            } else {
                              el.play().catch(() => {}); // Retoma se voltar a aparecer
                            }
                          });
                        }, { threshold: 0.5 }); // Deteta quando 50% do vídeo sai da tela
                        observer.observe(el);
                      }
                    }}
                              onClick={(e) => {
            // 🔊 ACENDE O BOTÃO DE SOM: Ao tocar no vídeo, o botão do som acorda por 1 segundo!
            setMostrarAlertaSom(true);
            if (window.timerAlertaSomFeed) clearTimeout(window.timerAlertaSomFeed);
            window.timerAlertaSomFeed = setTimeout(() => {
              setMostrarAlertaSom(false);
            }, 1000);

            if (e.target.paused) {
              e.target.play().catch(() => {});
            } else {
              e.target.pause();
            }
          }}
                  />
                  
                          {/* 🔊 BOTÃO DE SOM INTELIGENTE (ESTILO TIKTOK - DESAPARECE APÓS 1 SEGUNDO) */}
        {mostrarAlertaSom && (
          <div 
            onClick={(e) => {
              e.stopPropagation();
              setSomAtivoGlobal(!somAtivoGlobal);
              
              // Mantém o alerta vivo por mais 1 segundo se continuar a clicar
              if (window.timerAlertaSomFeed) clearTimeout(window.timerAlertaSomFeed);
              window.timerAlertaSomFeed = setTimeout(() => {
                setMostrarAlertaSom(false);
              }, 1000);
            }}

                    style={{
                                    position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(0, 0, 0, 0.7)',
              borderRadius: '50%',
              width: '45px',
              height: '45px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              zIndex: 999,
              border: '2px solid #39FF14',
              boxShadow: '0 0 10px rgba(57, 255, 20, 0.4)'
                    }}
                  >
                    <span style={{ fontSize: '18px' }}>{somAtivoGlobal ? "🔊" : "🔇"}</span>
                  </div>
                          )}

                </div>

                ) : (
                  <div className="main-video" style={{ background: 'black' }}></div>
                )
              ) : (
  <img 
    src={post.url} 
    alt="Post" 
    style={{ width: '100vw', height: '100vh', objectFit: 'cover', backgroundColor: '#111' }}
  />
)}

        <div className="video-info" style={{ display: 'flex', alignItems: 'center', gap: '12px', zIndex: 10 }}>
                {/* FOTO DE PERFIL COM ARO NEON */}
                <div 
                  onClick={() => {
                    setPerfilVisitado({ uid: post.userId, nomeCompleto: post.userName, fotoUrl: post.userFoto });
                    setAbaGrelha('videos');
                    setEcraAtivo('perfil');
                  }}
                  style={{ position: 'relative', cursor: 'pointer' }}
                >
                  <img 
                    src={post.userFoto || "https://gravatar.com"}
                    style={{ 
                      width: '45px', 
                      height: '45px', 
                      borderRadius: '50%', 
                      border: '2px solid #39FF14', 
                      boxShadow: '0 0 10px #39FF14', 
                      objectFit: 'cover' 
                    }} 
                    alt=""
                  />
                  
                  {/* BOTÃO + (SÓ APARECE SE NÃO FORES TU) */}
                  {post.userId !== auth.currentUser?.uid && !meusSeguidos.includes(post.userId) && (
                    <div 
                      onClick={(e) => {
                        e.stopPropagation(); // Para não abrir o perfil ao clicar no +
                        seguirPeloFeed(post.userId, post.userName);
                      }}
                      style={{
                        position: 'absolute', bottom: '-2px', right: '50%', transform: 'translateX(50%)',
                        background: '#39FF14', color: 'black', borderRadius: '50%',
                        width: '18px', height: '18px', display: 'flex', justifyContent: 'center',
                        alignItems: 'center', fontSize: '14px', fontWeight: '900', border: '1px solid black'
                      }}
                    >+</div>
                  )}
                </div>

                {/* NOME E LEGENDA */}
                <div onClick={() => { setPerfilVisitado({ uid: post.userId, nomeCompleto: post.userName }); setAbaGrelha('videos'); setEcraAtivo('perfil'); }} style={{ cursor: 'pointer' }}>
                  <h3 style={{ margin: 0, fontSize: '15px', color: 'white', fontWeight: 'bold' }}>{post.userName}</h3>
                  <p style={{ margin: 0, fontSize: '13px', color: '#eee' }}>{post.legenda || ""}</p>
                </div>
</div>

<div className="side-bar">
                                
    {/* =========================================================================
    BARRA LATERAL DE BOTÕES (SIDE-BAR) - MONETIZAÇÃO DUPLA & MULTILÍNGUE
    ========================================================================= */}
    {/* 1. CORAÇÃO: LIKE PARA VISITANTE / LISTA PARA DONO DO POST */}
    <div 
      className="action-btn" 
      onClick={async (e) => {
        e.stopPropagation();
        if (post.userId === auth.currentUser?.uid) {
          setIdPostAtivo(post);
          setMostrarListaLikes(true);
        } else {
          const result = await darLike(post.id, post.likes, post.curtidasRicas || [], post.userId);
          if (result && posts) {
            setPosts(prev => prev.map(p => p.id === post.id ? { ...p, likes: result.novoTotal, curtidasRicas: result.novaListaRica } : p));
          }
        }
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ 
          fontSize: '32px', 
          color: post.curtidasRicas?.some(c => c.userId === auth.currentUser?.uid) ? '#ff4444' : 'white',
          textShadow: post.curtidasRicas?.some(c => c.userId === auth.currentUser?.uid) ? '0 0 10px #ff4444' : 'none'
        }}>
          💖
        </span>
        <span style={{ fontSize: '14px', color: 'white', marginTop: '-5px', fontWeight: 'bold', cursor: 'pointer' }}>
          {post.likes || 0}
        </span>
      </div>
    </div>

    {/* 2. COMENTÁRIOS: CONTADOR NÉON BRILHANTE */}
    <div className="action-btn" onClick={() => {
      setIdPostAtivo(post);
      setMostrarComentarios(true);
    }} style={{ marginBottom: '20px', cursor: 'pointer' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
        <div style={{ 
          position: 'relative', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.2))'
        }}>
          <MessageCircle size={30} color="white" />
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#39FF14',
            fontSize: '9px',
            fontWeight: '900',
            textShadow: '0 0 5px #39FF14'
          }}>
            {post.totalComentarios > 99 ? '+99' : (post.totalComentarios || 0)}
          </span>
        </div>
        <span style={{ fontSize: '11px', color: '#aaa', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Chats
        </span>
      </div>
    </div>

    {/* 3. PARTILHAR: VERSÃO INTERNACIONAL */}
    <div className="action-btn" onClick={async (e) => {
      e.stopPropagation();
      partilharPost(post);
    }} style={{ marginBottom: '20px', cursor: 'pointer' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px', filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.2))' }}>
        <Share2 size={30} color="white" />
        <span style={{ fontSize: '11px', color: '#aaa', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          {t.botoes.enviar}
        </span>
      </div>
    </div>

    {/* 4. BALDE DO LIXO PARA O DONO / ENVIAR CROMOS E GIFTS PARA VISITANTES */}
    {post.userId === auth.currentUser?.uid ? (
      <div className="action-btn" onClick={async () => {
        const confirmarEliminar = {
          pt: "Queres eliminar este post do estádio? 🗑️",
          en: "Do you want to delete this post from the stadium? 🗑️",
          es: "¿Quieres eliminar esta publicación del estadio? 🗑️",
          fr: "Voulez-vous supprimer este post do estádio ? 🗑️"
        }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || "Do you want to delete this post? 🗑️";

        const sucessoEliminar = {
          pt: "Post eliminado! ⚽",
          en: "Post deleted! ⚽",
          es: "¡Publicación eliminada! ⚽",
          fr: "Post supprimé ! ⚽"
        }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || "Post deleted! ⚽";

        if (window.confirm(confirmarEliminar)) {
          const { doc, deleteDoc } = await import('firebase/firestore');
          await deleteDoc(doc(db, "posts", post.id));
          alert(sucessoEliminar);
        }
      }} style={{ fontSize: '26px', cursor: 'pointer', textAlign: 'center', marginTop: '15px', filter: 'drop-shadow(0 0 5px #ff4444)' }}>
        🗑️
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px', marginTop: '10px' }}>
        
        {/* BOTÃO A: TREVO DA SORTE (ENVIA STICKERS PARA A CADERNETA) */}
        <div className="action-btn" onClick={() => { 
          setIdPostAtivo(post); 
          setAbaAtual('stickers'); // Força a abertura na aba dos stickers da caderneta
          setMostrarPresentes(true); 
        }} style={{ cursor: 'pointer' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <div style={{
              width: '42px',
              height: '42px',
              background: 'linear-gradient(135deg, #13ad00 0%, #39FF14 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 12px rgba(57, 255, 20, 0.6)',
              border: '1.5px solid #FFF',
              animation: 'pulse 2s infinite'
            }}>
              <Clover size={22} color="black" fontWeight="900" />
            </div>
            <span style={{ fontSize: '10px', color: '#39FF14', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.5px', textShadow: '0 0 4px rgba(57,255,20,0.4)' }}>
              {t.botoes.caderneta}
            </span>
          </div>
        </div>

        {/* BOTÃO B: CAIXINHA AMARELA (ENVIA OS PRESENTES PREMIUM DE VÍDEO 3D) */}
        <div className="action-btn" onClick={() => { 
          setIdPostAtivo(post); 
          setAbaAtual('videos'); // Força a abertura na aba dos vídeos premium do Kling AI
          setMostrarPresentes(true); 
        }} style={{ cursor: 'pointer' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <div style={{
              width: '42px',
              height: '42px',
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 12px rgba(255, 215, 0, 0.6)',
              border: '1.5px solid #FFF',
              animation: 'pulse 2s infinite'
            }}>
              <Gift size={22} color="black" />
            </div>
            <span style={{ fontSize: '10px', color: '#FFD700', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.5px', textShadow: '0 0 4px rgba(255,215,0,0.4)' }}>
              {t.botoes.presentes}
            </span>
          </div>
        </div>

      </div>
    )}
  </div>

    {/* ANIMAÇÃO DE STICKER NO POST (FLUTUANTE E TOTALMENTE TRANSPARENTE) */}
{presenteAtivo && presenteAtivo.postId === post.id && (
  <div style={{
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent', /* Fundo transparente para não tapar o feed */
    zIndex: 9999999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none' /* Permite continuar a mexer no feed enquanto o sticker passa */
  }}>
    {presenteAtivo.url?.toLowerCase().endsWith('.mp4') || presenteAtivo.url?.toLowerCase().endsWith('.webm') ? (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'black',
    zIndex: 9999999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <video
      key={presenteAtivo.url}
      src={presenteAtivo.url}
      autoPlay
      playsInline
      muted={false}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      }}
      onEnded={() => setPresenteAtivo(null)}
    />
  </div>
) : (

      <img
        key={presenteAtivo.url}
        src={presenteAtivo.url}
        alt="Sticker"
        style={{ 
          width: '180px',
          height: '180px',
          objectFit: 'contain'
        }}
        onLoad={() => setTimeout(() => setPresenteAtivo(null), 3000)}
      />
    )}
  </div>
)}

            </div>
          );
        })
      ) : ecraAtivo === 'perfil' ? (
        /* A barreira devolve um ecrã com mensagem e botão de saída se algo
           rebentar aqui dentro. Sem ela, o React desmontava a app inteira e
           sobrava o fundo preto do <body> — o "ecrã preto" reportado. */
        <ErrorBoundary ecra="perfil" aoRecuperar={() => setEcraAtivo('feed')}>
          <Perfil 
            userDados={perfilVisitado || dadosUtilizador} 
            abaGrelha={abaGrelha} 
            setAbaGrelha={setAbaGrelha} 
            postsDoFeed={postsFiltradosTikTok}
            darLike={darLike}
            saldoBolas={dadosUtilizador?.saldoBolas || 0}
            presenteAtivo={presenteAtivo}
            setPresenteAtivo={setPresenteAtivo}
            setMostrarPresentes={setMostrarPresentes}
            setIdPostAtivo={setIdPostAtivo}
            dadosPerfil={perfilVisitado || dadosUtilizador}
            perfilAlvoId={perfilVisitado?.uid || dadosUtilizador?.uid}
            setEcraAtivo={setEcraAtivo}
            setDadosUtilizador={setDadosUtilizador}
          />
        </ErrorBoundary>
      ) : ecraAtivo === 'carteira' ? (
        <ErrorBoundary ecra="carteira" aoRecuperar={() => setEcraAtivo('perfil')}>
          <Levantamentos userDados={perfilVisitado || dadosUtilizador} setEcraAtivo={setEcraAtivo} />
        </ErrorBoundary>

      ) : ecraAtivo === 'live_campo' ? (
        /* O ecrã da live é renderizado UMA única vez mais abaixo (bloco ecraAtivo === 'live_campo').
           Ter aqui uma segunda instância criava 2 ligações Agora em simultâneo e tapava o vídeo. */
        null
      ) : ecraAtivo === 'perfil_suspenso' ? (
        <div style={{ 
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 
          backgroundColor: 'black', zIndex: 1000040, overflowY: 'auto' 
        }}>

        {/* INSTÂNCIA COMPLETA DO PERFIL COM DADOS E ACÇÕES REAIS */}
          <ErrorBoundary ecra="perfil_suspenso" aoRecuperar={() => setEcraAtivo('feed')}>
            <Perfil 
              userDados={dadosUtilizador} 
              abaGrelha={abaGrelha} 
              setAbaGrelha={setAbaGrelha} 
              postsDoFeed={postsFiltradosTikTok}
              darLike={darLike}
              saldoBolas={saldoBolas}
              setSaldoBolas={setSaldoBolas}
              presenteAtivo={presenteAtivo}
              setPresenteAtivo={setPresenteAtivo}
              setMostrarPresentes={setMostrarPresentes}
              setIdPostAtivo={setIdPostAtivo}
              dadosPerfil={dadosUtilizador}
            />
          </ErrorBoundary>
        </div>
      ) : ecraAtivo === 'champions_pk' ? (
        /* ECRÃ DA CHAMPIONS PK (BANCADA DO TORNEIO) EM MODO ESPECTADOR */
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000050, background: '#000', overflow: 'hidden' }}>
          <TorneiosPK
            idBatalha={dadosUtilizador?.batalhaId}
            idJogoNaArvore={dadosUtilizador?.id}
            aoSair={() => setEcraAtivo('feed')}
            espectador={true}
          />
        </div>
      ) : ecraAtivo === 'arena_pk' ? (
        /* ECRÃ DA ARENA PK OU LIGA PK EM MODO ESPECTADOR (ISOLADO E ANTICOLISSÃO) */
        dadosUtilizador?.isLiga ? (
          <div style={{ position: 'fixed', inset: 0, zIndex: 1000050, background: '#000', overflow: 'hidden' }}>
            <JogosLigaPK
              idLiga={dadosUtilizador?.idLiga}
              chaveJornada={dadosUtilizador?.chaveJornada || "jornada_1"}
              idJogoNaJornada={dadosUtilizador?.idJogo || dadosUtilizador?.id || dadosUtilizador?.batalhaId}
              idBatalha={dadosUtilizador?.idJogo || dadosUtilizador?.id || dadosUtilizador?.batalhaId}
              espectador={true}
              aoSair={() => setEcraAtivo('feed')}
            />
          </div>
        ) : (
          <div style={{ position: 'fixed', inset: 0, zIndex: 1000050, background: '#000', overflowY: 'auto' }}>
            <ArenaPK
              batalhaId={dadosUtilizador?.batalhaId}
              aoSair={() => setEcraAtivo('feed')}
            />
          </div>
        )
      ) : (
        /* ECRÃ DE MENSAGENS REAL - BALNEÁRIO LOCALIZADO (TRANCADO CONTRA PISCAR VISUAL) */
        <div style={{ display: ecraAtivo === 'mensagens' ? 'block' : 'none', width: '100vw', height: '100vh', background: 'black', paddingTop: '100px', textAlign: 'center', overflowY: 'auto' }}>
          {!conversaAtiva ? (
            <>
              <h2 style={{ color: '#39FF14' }}>
                {(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "BALNEÁRIO DE CHAT ⚽" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "VESTUARIO DE CHAT ⚽" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'fr' ? "VESTIAIRE DE CHAT ⚽" : "CHAT LOCKER ROOM ⚽"}
              </h2>
            {/* BOTÕES DAS ABAS LOCALIZADOS */}
<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', margin: '20px 10px' }}>
  <button 
    onClick={() => setAbaBalneario('alertas')}
    style={{
      flex: 1, padding: '12px', borderRadius: '12px', border: 'none',
      backgroundColor: abaBalneario === 'alertas' ? '#39FF14' : '#1a1a1a',
      color: abaBalneario === 'alertas' ? 'black' : 'white',
      fontWeight: 'bold', cursor: 'pointer', fontSize: '11px',
      boxShadow: abaBalneario === 'alertas' ? '0 0 10px #39FF14' : 'none'
    }}
  >
        {(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "NOTIFICAÇÕES 🔔" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "NOTIFICACIONES 🔔" : "NOTIFICATIONS 🔔"}

  </button>
  <button 
    onClick={() => setAbaBalneario('mensagens')}
    style={{
      flex: 1, padding: '12px', borderRadius: '12px', border: 'none',
      backgroundColor: abaBalneario === 'mensagens' ? '#39FF14' : '#1a1a1a',
      color: abaBalneario === 'mensagens' ? 'black' : 'white',
      fontWeight: 'bold', cursor: 'pointer', fontSize: '11px',
      boxShadow: abaBalneario === 'mensagens' ? '0 0 10px #39FF14' : 'none'
    }}
  >
        {(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "MENSAGENS 💬" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "MENSAJES 💬" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'fr' ? "MESSAGES 💬" : "MESSAGES 💬"}

  </button>
</div>

<div style={{ marginTop: '20px' }}>
 {/* ABA DE ALERTAS/NOTIFICAÇÕES — INJEÇÃO DO FUNDO VIDEO */}
  {abaBalneario === 'alertas' && (
    <div style={{
      backgroundImage: `url(${fundoVideoImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '60vh',
      borderRadius: '10px'
    }}>
      <ListaNotificacoes 
        aoClicar={(id) => { 
          setPerfilVisitado({ uid: id }); 
          setAbaGrelha('videos');
          setEcraAtivo('perfil'); 
        }} 
      />
    </div>
  )}

  {/* ABA DE MENSAGENS PRIVADAS — INJEÇÃO DO FUNDO AUDIO */}
  {abaBalneario === 'mensagens' && (
    <div style={{ 
      padding: '15px 10px',
      backgroundImage: `url(${fundoAudioImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '60vh',
      borderRadius: '10px'
    }}>
      {/* CAMPO DE PESQUISA INTERNA (LUPINHA MULTILÍNGUE) */}
      <div style={{ display: 'flex', alignItems: 'center', background: '#1a1a1a', borderRadius: '25px', padding: '4px 12px', marginBottom: '15px', border: '1px solid #333' }}>
        <span style={{ marginRight: '8px', fontSize: '14px' }}>🔍</span>
        <input
          type="text"
          
          placeholder={(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "Pesquisa por amigos no estádio..." : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "Busca amigos en el estadio..." : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'fr' ? "Rechercher des amis dans le stade..." : "Search for friends in the stadium..."}

          value={pesquisaBalneario}
          onChange={(e) => setPesquisaBalneario(e.target.value)}
          style={{ flex: 1, background: 'none', border: 'none', color: 'white', fontSize: '15px', outline: 'none' }}
        />
        {pesquisaBalneario && (
          <button
            onClick={() => setPesquisaBalneario("")}
            style={{ background: 'none', border: 'none', color: '#ff4444', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', padding: '0 5px' }}
          >
            ✕
          </button>
        )}
      </div>

      {/* LISTAGEM DE AMIGOS COM CRUTAMENTO RESTRITO (MÚTUO) - MULTILÍNGUE */}
              {utilizadores && utilizadores.length > 0 ? (
                (() => {
                  const amigosFiltrados = utilizadores.filter(u => {
                    const meuUid = auth.currentUser?.uid;
                    
                    // 1. Trancas básicas de segurança obrigatórias
                    if (u.uid === meuUid) return false;
                    if (meusBloqueados.includes(u.uid) || quemMeBloqueou.includes(u.uid)) return false;
                    
                    // 2. Filtro Inteligente da Lupinha
                    if (pesquisaBalneario && pesquisaBalneario.trim() !== "") {
                      const nomeProcurado = String(u.nomeCompleto || "").toLowerCase();
                      const termo = pesquisaBalneario.toLowerCase();
                      return nomeProcurado.includes(termo);
                    }
                    
                    // Se a caixa estiver vazia, só mostra quem for seguidor ou seguido para não encher o ecrã
                    const euSigoAPessoa = meusSeguidos && meusSeguidos.includes(u.uid);
                    const aPessoaMeSegue = meusSeguidoresIds && meusSeguidoresIds.includes(u.uid);
                    return euSigoAPessoa || aPessoaMeSegue;
                  });

      if (amigosFiltrados.length === 0) {
                    return (
                      <p style={{ color: '#666', fontSize: '12px', marginTop: '20px' }}>
                        {(() => {
                          const lg = (navigator.language || navigator.userLanguage || "pt").toLowerCase().split('-')[0];
                          if (lg === 'es') return "¡No se encontraron compañeros de hinchada mutuos! ⚽";
                          if (lg === 'fr') return "Aucun supporter mutuel trouvé... ⚽";
                          if (lg === 'en') return "No mutual fans found... ⚽";
                          return "Nenhum parceiro de claque mútuo encontrado... ⚽";
                        })()}
                      </p>
                    );
                  }

                  return amigosFiltrados.map(u => (
                    <div key={u.uid} onClick={() => { setPesquisaBalneario(""); setConversaAtiva(u); }} style={{ padding: '15px', borderBottom: '1px solid #222', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                      <img src={u.fotoUrl || "/hero.png"} style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} alt="foto" onError={(e) => { e.target.src = '/hero.png'; }} />
                      <span style={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>{u.nomeCompleto || u.nome || "Craque"}</span>
                    </div>
                  ));
                })()
              ) : (
                <p style={{ color: '#666' }}>
                  {(() => {
                    const lg = (navigator.language || navigator.userLanguage || "pt").toLowerCase().split('-')[0];
                    if (lg === 'es') return "Buscando cracks en el estadio... ⚽";
                    if (lg === 'fr') return "Recherche de cracks dans le stade... ⚽";
                    if (lg === 'en') return "Looking for players in the stadium... ⚽";
                    return "À procura de craques no estádio... ⚽";
                  })()}
                </p>
              )}
            </div>
          )}
        </div>
      </>
    ) : (
    <div style={{ 
  display: ecraAtivo === 'mensagens' ? 'flex' : 'none', 
  flexDirection: 'column', 
  height: '75vh', 
  position: 'relative',
  backgroundImage: `url(${fundoPerfilImg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
}}>

  <button 
    onClick={() => setConversaAtiva(null)} 
    style={{ color: '#39FF14', background: 'none', border: 'none', alignSelf: 'flex-start', padding: '10px', cursor: 'pointer', fontWeight: 'bold' }}
  >
    {(() => {
      const lg = (navigator.language || navigator.userLanguage || "pt").toLowerCase().split('-')[0];
      if (lg === 'es') return "← VOLVER";
      if (lg === 'fr') return "← RETOUR";
      if (lg === 'en') return "← BACK";
      return "← VOLTAR";
    })()}
  </button>
  {/* Tranca sem o @ a pedido do Miguel */}
  <h3 style={{ color: 'white', textAlign: 'center' }}>{conversaAtiva?.nomeCompleto || conversaAtiva?.nome || "Craque"}</h3>

      {/* LISTA DE MENSAGENS REAL */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '15px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {mensagensChat.map((m) => {
                  const souEu = m.enviadoPor === auth.currentUser?.uid;
                  return (
                    <div key={m.id} style={{
                      alignSelf: souEu ? 'flex-end' : 'flex-start',
                      background: souEu ? '#39FF14' : '#222',
                      color: souEu ? 'black' : 'white',
                      padding: '8px 15px', borderRadius: '15px', maxWidth: '80%', fontSize: '14px', fontWeight: 'bold'
                    }}>
                      {m.texto}
                    </div>
                  );
                })}
              </div>

              {/* CAMPO DE ESCRITA FIXO NO FUNDO INTERNACIONALIZADO CORRIGIDO */}
              <div style={{ display: 'flex', gap: '10px', padding: '10px', background: '#000', borderTop: '1px solid #222' }}>
                <input 
                  value={mensagemTexto} 
                  onChange={(e) => setMensagemTexto(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && enviarMensagem()}
                  placeholder={(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "Escreve aqui..." : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "Escribe aquí..." : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'fr' ? "Écris ici..." : "Type here..."} 
                  style={{ flex: 1, background: '#111', border: '1px solid #333', color: 'white', borderRadius: '20px', padding: '10px' }}
                />
                <button onClick={enviarMensagem} style={{ background: 'none', border: 'none', fontSize: '25px', cursor: 'pointer' }}>⚽</button>
              </div>
            </div>
          )}
        </div>
      )}

                  {/* CHAMADA DINÂMICA COMPLETA DO MENU DE PRESENTES */}
      {mostrarPresentes && (
        <MenuPresentes 
          aoFechar={() => setMostrarPresentes(false)} 
          aoEnviar={(idDoItem, videoUrl, precoBolas, post, nomePresente) => dispararPresente(idDoItem, videoUrl, precoBolas, post, nomePresente)}
          postAlvo={idPostAtivo}
          abaInicial={abaAtual}
          db={db} 
          auth={auth} 
        />
      )}

    {/* ECRÃ DE EXPLORAR/PESQUISA - MULTILÍNGUE COM SAFE AREA */}
      {ecraAtivo === 'pesquisa' && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundColor: '#000', 
          zIndex: 100, 
          paddingTop: 'calc(60px + env(safe-area-inset-top))' // Margem de segurança dinâmica mundial
        }}>
          <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <button 
              onClick={() => setEcraAtivo('feed')}
              style={{ alignSelf: 'flex-start', background: 'none', border: 'none', color: '#39FF14', fontWeight: 'bold', marginBottom: '15px', cursor: 'pointer' }}
            >
              {
                {
                  pt: "✕ CANCELAR",
                  en: "✕ CANCEL",
                  es: "✕ CANCELAR",
                  fr: "✕ ANNULER"
                }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || "✕ CANCELAR"
              }
            </button>
            <input 
              type="text" 
              placeholder={
                {
                  pt: "Pesquisar craques...",
                  en: "Search players...",
                  es: "Buscar cracks...",
                  fr: "Rechercher des cracks..."
                }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || "Pesquisar craques..."
              }
              onChange={(e) => {
                const termo = e.target.value.toLowerCase();
                const filtrados = utilizadores.filter(u => u.nomeCompleto?.toLowerCase().includes(termo));
                setResultadosPesquisa(termo === "" ? [] : filtrados);
              }}
              style={{ width: '90%', padding: '12px', borderRadius: '10px', border: 'none', background: '#222', color: 'white', outline: 'none' }}
            />
            <div style={{ width: '100%', marginTop: '20px', overflowY: 'auto', maxHeight: '70vh' }}>
              {resultadosPesquisa.map(u => (
                <div 
                  key={u.uid} 
                  onClick={() => { setPerfilVisitado(u); setAbaGrelha('videos'); setEcraAtivo('perfil'); }}
                  style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px', borderBottom: '1px solid #111', cursor: 'pointer' }}
                >
                  <img src={u.fotoUrl || u.photoURL || "https://gravatar.com"} style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} alt="" />
                  <span style={{ color: 'white', fontWeight: 'bold' }}>{u.nomeCompleto}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* CORTINA DE PARTILHA PRIVADA INTERNA LOCALIZADA */}
      {mostrarListaPartilha && (
        <div style={{ 
          position: 'fixed', bottom: 0, left: 0, width: '100%', height: '420px',
          background: '#050505', padding: '20px', 
          borderTop: '2px solid #39FF14', borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
          zIndex: 999999, color: 'white', fontFamily: 'sans-serif',
          display: 'flex', flexDirection: 'column', boxSizing: 'border-box'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <span style={{ fontSize: '15px', fontWeight: '900', color: '#39FF14' }}>
              {
                {
                  pt: "ENVIAR JOGADA PRIVADA ⚽",
                  en: "SEND PRIVATE POST ⚽",
                  es: "ENVIAR PUBLICACIÓN PRIVADA ⚽",
                  fr: "ENVOYER POST PRIVÉ ⚽"
                }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "SEND PRIVATE POST ⚽"
              }
            </span>
            <button 
              onClick={() => setMostrarListaPartilha(false)}
              style={{ background: 'none', border: 'none', color: '#39FF14', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
            >
              X
            </button>
          </div>

          <div style={{ flex: 1, overflowY: 'scroll', WebkitOverflowScrolling: 'touch', paddingBottom: '20px' }}>
            {utilizadoresApp.length === 0 ? (
              <div style={{ color: '#aaa', textAlign: 'center', marginTop: '50px', fontSize: '13px' }}>
                {
                  {
                    pt: "A procurar craques no estádio...",
                    en: "Looking for players in the stadium...",
                    es: "Buscando cracks en el estadio...",
                    fr: "Recherche de cracks dans le stade..."
                  }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "Looking for players..."
                }
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {utilizadoresApp.map(u => (
                  <div 
                    key={u.id}
                    onClick={() => dispararPartilhaPrivada(u.id)}
                    style={{ 
                      display: 'flex', alignItems: 'center', gap: '12px', 
                      backgroundColor: '#151515', border: '1px solid #252525', 
                      borderRadius: '12px', padding: '10px 15px', cursor: 'pointer' 
                    }}
                  >
                    <img 
                      src={u.fotoUrl || "https://gravatar.com"} 
                      style={{ width: '35px', height: '35px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} 
                      alt="" 
                    />
                    <span style={{ color: 'white', fontSize: '13px', fontWeight: 'bold' }}>
                      {u.nomeCompleto || 
                        {
                          pt: "Craque Anónimo",
                          en: "Anonymous Player",
                          es: "Crack Anónimo",
                          fr: "Crack Anonyme"
                        }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "Anonymous Player"
                      }
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
 
      {/* CORTINA DE COMENTÁRIOS (Sobe de baixo) */}
      {mostrarComentarios && idPostAtivo && (
        <div style={{ 
          position: 'fixed', bottom: 0, left: 0, width: '100%', height: '70vh', 
          backgroundImage: `url(${fundoLuckys})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: '#111', zIndex: 1000000, borderTopLeftRadius: '25px',  
          borderTopRightRadius: '25px', display: 'flex', flexDirection: 'column',
          boxShadow: '0 -5px 20px rgba(0,0,0,0.5)', borderTop: '1px solid #333'
        }}>
          {/* TOPO DA CORTINA */}
          <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #222' }}>
            <h3 style={{ color: 'white', margin: 0 }}>{t.comentarios.titulo}</h3>
            <button 
              onClick={() => { setMostrarComentarios(false); setIdPostAtivo(null); }}
              style={{ background: 'none', border: 'none', color: '#39FF14', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
            >X</button>
          </div>

                    {/* LISTA DE MENSAGENS EM ÁRVORE */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
            {listaComentarios.length > 0 ? listaComentarios.map(com => {
              // Componente interno temporário para gerir as respostas de cada comentário
              return (
                <div key={com.id} style={{ marginBottom: '20px', borderBottom: '1px solid #1a1a1a', paddingBottom: '15px' }}>
                  {/* COMENTÁRIO PRINCIPAL */}
                                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <img 
                      src={com.userFoto || com.remetenteFoto || "https://gravatar.com"} 
                      style={{ width: '32px', height: '32px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover', marginTop: '2px', cursor: 'pointer' }}
                                          onClick={() => {
                      setPerfilVisitado({ uid: com.userId || com.utilizadorId });
                      setEcraAtivo('perfil');
                      setMostrarComentarios(false);
                    }}
                      alt=""
                    />
                    <div style={{ flex: 1 }}>
                      <span 
                                            onClick={() => {
                      setPerfilVisitado({ uid: com.userId || com.utilizadorId });
                      setEcraAtivo('perfil');
                      setMostrarComentarios(false);
                    }}
                        style={{ color: '#39FF14', fontWeight: 'bold', fontSize: '14px', display: 'inline-block', cursor: 'pointer' }}
                      >
                        {com.userName}
                      </span>
                    <span style={{ color: 'white', fontSize: '14px', display: 'block', marginTop: '4px' }}>{com.texto}</span>
                    
                    <div style={{ display: 'flex', gap: '15px', marginTop: '6px', alignItems: 'center' }}>
                      <span 
                        onClick={() => setComentarioAInteragir(com)}
                        style={{ color: '#666', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                      >
                        Responder
                      </span>
                      </div>

                      {(com.userId === auth.currentUser?.uid || com.utilizadorId === auth.currentUser?.uid) && (
                        <span 
                          onClick={async () => {
                            if (window.confirm("Queres mesmo apagar o teu comentário? ⚽")) {
                              try {
                                const { doc, deleteDoc } = await import('firebase/firestore');
                                await deleteDoc(doc(db, "posts", idPostAtivo.id, "comentarios", com.id));
                              } catch (e) { console.error("Erro ao apagar:", e); }
                            }
                          }}
                          style={{ color: '#ff4444', fontSize: '12px', cursor: 'pointer' }}
                        >
                          Apagar
                        </span>
                      )}
                    </div>
                  </div>

                  {/* SUBCOLEÇÃO DE RESPOSTAS (RECUADAS À DIREITA) */}
                                  <ItemRespostas 
                  db={db} 
                  auth={auth} 
                  postId={idPostAtivo.id} 
                  comentarioId={com.id} 
                  setDadosUtilizador={setDadosUtilizador} 
                  setPerfilVisitado={setPerfilVisitado}
                  setEcraAtivo={setEcraAtivo} 
                  setMostrarComentarios={setMostrarComentarios} 
                  setComentarioAInteragir={setComentarioAInteragir} 
                  paiCompleto={com} 
                />
                </div>
              );
            }) : (
              <p style={{ color: '#555', textAlign: 'center', marginTop: '50px' }}>{t.comentarios.vazio}</p>
            )}
          </div>

                    {/* CAMPO PARA ESCREVER COM SUPORTE A RESPOSTAS */}
          <div style={{ background: '#000', padding: '20px', paddingBottom: 'calc(20px + env(safe-area-inset-bottom))', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            
            {/* BARRA INDICAÇÃO DE RESPOSTA */}
            {comentarioAInteragir && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#222', padding: '8px 15px', borderRadius: '10px' }}>
                <span style={{ color: '#aaa', fontSize: '12px' }}>
                  A responder a <strong style={{ color: '#39FF14' }}>{comentarioAInteragir.userName}</strong>
                </span>
                <span 
                  onClick={() => setComentarioAInteragir(null)} 
                  style={{ color: '#ff4444', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                >
                  Cancelar
                </span>
              </div>
            )}

                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
              <input 
                type="text" 
                value={novoComentario}
                onChange={(e) => setNovoComentario(e.target.value)}
                placeholder={comentarioAInteragir ? 
  {
    pt: "Escreve a tua resposta...",
    en: "Write your reply...",
    es: "Escribe tu respuesta...",
    fr: "Écris ta réponse..."
  }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')[0]] || "Write your reply..."
  : t.comentarios.placeholder
} 
                style={{ flex: 1, padding: '12px', borderRadius: '25px', border: 'none', background: '#222', color: 'white', outline: 'none' }}
              />
                          <button 
                onClick={async () => {
                  if (!novoComentario.trim()) return;
                  // Executa a função profissional que grava e gera as notificações
                  await enviarComentario();
                  // 🟢 LIMPEZA IMEDIATA FORÇADA NO CLIQUE DO ECRÃ
                  setNovoComentario("");
                  setComentarioAInteragir(null);
                }}
                style={{ background: '#39FF14', color: 'black', border: 'none', borderRadius: '50%', width: '45px', height: '45px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                ⚽
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CORTINA DE LIKES RICOS LOCALIZADA */}
      {mostrarListaLikes && idPostAtivo && (
        <div style={{ 
          position: 'fixed', bottom: 0, left: 0, width: '100%', height: '50vh', 
          backgroundColor: '#111', zIndex: 1000001, borderTopLeftRadius: '25px', 
          borderTopRightRadius: '25px', display: 'flex', flexDirection: 'column',
          boxShadow: '0 -5px 20px rgba(0,0,0,0.5)', borderTop: '1px solid #333'
        }}>
          <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #222' }}>
            <h3 style={{ color: 'white', margin: 0 }}>
              {
                {
                  pt: "Quem curtiu ⚽",
                  en: "Who liked ⚽",
                  es: "A quién le gustó ⚽",
                  fr: "Qui a aimé ⚽"
                }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "Who liked ⚽"
              }
            </h3>
            <button 
              onClick={() => { setMostrarListaLikes(false); }}
              style={{ background: 'none', border: 'none', color: '#39FF14', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
            >X</button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
            {idPostAtivo.curtidasRicas && idPostAtivo.curtidasRicas.length > 0 ? (
              idPostAtivo.curtidasRicas.map((fa, index) => (
                <div 
                  key={index}
                  onClick={() => { 
                    setPerfilVisitado({
                      uid: fa.userId,
                      nomeCompleto: fa.userName,
                      fotoUrl: fa.userFoto
                    });
                    setAbaGrelha('videos');
                    setEcraAtivo('perfil'); 
                    setMostrarListaLikes(false); 
                  }}
                  style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 0', borderBottom: '1px solid #1a1a1a', cursor: 'pointer' }}
                >
                  <img src={fa.userFoto || "https://gravatar.com"} style={{ width: '35px', height: '35px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} alt="" />
                  <span style={{ color: 'white', fontWeight: 'bold' }}>{fa.userName}</span>
                </div>
              ))
            ) : (
              <p style={{ color: '#555', textAlign: 'center', marginTop: '30px' }}>
                {
                  {
                    pt: "Nenhum craque curtiu ainda. ⚽",
                    en: "No players liked yet. ⚽",
                    es: "A ningún crack le ha gustado aún. ⚽",
                    fr: "Aucun crack n'a encore aimé. ⚽"
                  }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "No players liked yet. ⚽"
                }
              </p>
            )}
          </div>
        </div>
      )}
          
                          {/* ECRÃ DA BANCADA (SALA DE VOZ/VÍDEO) - ESTABILIDADE ABSOLUTA CONTRA LOOPS */}
          {ecraAtivo === 'bancada' && (
            (() => {
              if (!window.agoraClientEstadio) {
                window.agoraClientEstadio = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
              }
              return (
                <AgoraRTCProvider client={window.agoraClientEstadio}>
                  <BancadaSala
                    aoSair={() => setEcraAtivo('feed')}
                    dadosUtilizador={dadosUtilizador}
                  />
                </AgoraRTCProvider>
              );
            })()
          )}

                    {/* ECRÃ DA TV (HUB CENTRAL: LISTA DE LIVES E BANCADAS) */}
          {ecraAtivo === 'tv' && (
            <TelevisaoListas 
              aoSair={() => setEcraAtivo('feed')}
              setEcraAtivo={setEcraAtivo}
              setDadosUtilizador={setDadosUtilizador}
            />
          )}

                    {/* ECRÃ DA TRANSMISSÃO EM DIRETO (LIVE DO CAMPO) */}
          {ecraAtivo === 'live_campo' && (
            <LiveCampo
              aoSair={() => { setPerfilSobreLive(null); setEcraAtivo('feed'); }}
              idCanalLive={dadosUtilizador?.liveId || dadosUtilizador?.uid}
              emLive={dadosUtilizador?.uid === auth.currentUser?.uid}
              dadosUtilizador={dadosUtilizador}
              setDadosUtilizador={setDadosUtilizador}
              setEcraAtivo={setEcraAtivo}
              verPerfilNaLive={(u) => setPerfilSobreLive(u)}
            />
          )}

                              {/* ECRÃ DA GALERIA DE CADERNETAS (LIVRO DE CROMOS) */}
          {ecraAtivo === 'caderneta_galeria' && (
            <CadernetaGaleria
              db={db}
              auth={auth}
              aoSair={() => setEcraAtivo('perfil')}
            />
          )}

          {/* PERFIL DO ESPETADOR SOBREPOSTO À LIVE - COM MULTILÍNGUE E SAFE AREA */}
          {ecraAtivo === 'live_campo' && perfilSobreLive && (
            <div style={{ position: 'fixed', inset: 0, zIndex: 2000000, backgroundColor: '#000', overflowY: 'auto' }}>
              <button
                onClick={() => setPerfilSobreLive(null)}
                style={{ 
                  position: 'fixed', 
                  top: 'calc(20px + env(safe-area-inset-top))', // Margem de segurança dinâmica contra notches
                  left: '15px', 
                  zIndex: 2000001, 
                  background: '#39FF14', 
                  color: '#000', 
                  border: 'none', 
                  borderRadius: '20px', 
                  padding: '8px 16px', 
                  fontWeight: '900', 
                  fontSize: '13px', 
                  cursor: 'pointer', 
                  boxShadow: '0 0 12px rgba(57,255,20,0.5)' 
                }}
              >
                {(navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'pt' ? "← VOLTAR À LIVE" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'es' ? "← VOLVER AL LIVE" : (navigator.language || navigator.userLanguage || "en").toLowerCase().substring(0, 2) === 'fr' ? "← RETOUR AU LIVE" : "← BACK TO LIVE"}

              </button>
              <ErrorBoundary ecra="perfil_na_live" aoRecuperar={() => setPerfilSobreLive(null)}>
                <Perfil
                  userDados={perfilSobreLive}
                  abaGrelha={abaGrelha}
                  setAbaGrelha={setAbaGrelha}
                  postsDoFeed={postsFiltradosTikTok}
                  darLike={darLike}
                  saldoBolas={saldoBolas}
                  setSaldoBolas={setSaldoBolas}
                  presenteAtivo={presenteAtivo}
                  setPresenteAtivo={setPresenteAtivo}
                  setMostrarPresentes={setMostrarPresentes}
                  setIdPostAtivo={setIdPostAtivo}
                  dadosPerfil={perfilSobreLive}
                  perfilAlvoId={perfilSobreLive?.uid}
                  setEcraAtivo={setEcraAtivo}
                  setDadosUtilizador={setDadosUtilizador}
                />
              </ErrorBoundary>
            </div>
          )}

            {/* BARRA DE NAVEGAÇÃO PRINCIPAL DO FUNDO (FOOTER) */}
      <div className="bottom-nav">
        {/* BOTÃO HOME: LEVA PARA O FEED DE VÍDEOS E FOTOS */}
        <Home 
          color={ecraAtivo === 'feed' ? '#39FF14' : 'white'} 
          size={24} 
          onClick={() => { setEcraAtivo('feed'); setAbaAtual('videos'); }}
          style={{ cursor: 'pointer' }} 
        />

                  {/* BOTÃO DA TV 📺 - HUB DE LISTAGEM DE LIVES E BANCADAS */}
          <Tv
            color={ecraAtivo === 'tv' ? '#39FF14' : 'white'}
            size={24}
            onClick={() => setEcraAtivo('tv')}
            style={{ cursor: 'pointer' }}
          />

                {/* 1.1 MICROFONE: PORTA DE ENTRADA EXCLUSIVA PARA AS SALAS DE BANCADA */}
          <Mic
            color={ecraAtivo === 'bancada' ? '#39FF14' : 'white'}
            size={24}
            onClick={() => setEcraAtivo('bancada')}
            style={{ cursor: 'pointer' }}
          />

        {/* BOTÃO + (UPLOAD): ADICIONA FOTOS OU VÍDEOS AUTOMATICAMENTE */}
        <label className="upload-btn" style={{ cursor: 'pointer' }}>
          {carregando ? "..." : <Plus size={30} color="black" />}
          <input 
            type="file" 
            accept={ecraAtivo === 'perfil' ? (abaGrelha === 'videos' ? "video/*" : "image/*") : "video/*,image/*"} 
            onChange={selecionarArquivoParaPost} 
            hidden 
          />
        </label>

    {/* BOTÃO CHAT (BALNEÁRIO): ABRE AS NOTIFICAÇÕES E AS MENSAGENS PRIVADAS */}
        <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { 
          setEcraAtivo('mensagens');
          setNotificacaoAtiva(false); 
        }}>
          <MessageCircle 
            color={ecraAtivo === 'mensagens' ? '#39FF14' : 'white'} 
            size={24} 
          />

          {notificacaoAtiva && (
            <span style={{
              position: 'absolute',
              top: '-2px',
              right: '-2px',
              width: '10px',
              height: '10px',
              backgroundColor: '#FF0000',
              borderRadius: '50%',
              boxShadow: '0 0 8px #FF0000',
              border: '1.5px solid black'
            }} />
          )}
        </div>

        <User 
          color={ecraAtivo === 'perfil' ? '#39FF14' : 'white'} 
          size={24} 
          onClick={() => {
            // ORDEM INVERTIDA DE PROPÓSITO: primeiro abre-se o ecrã, só depois
            // se vai buscar a ficha ao Firestore.
            if (typeof setPerfilVisitado === 'function') setPerfilVisitado(null);

            try {
              if (window.location.search !== '') {
                window.history.replaceState({}, '', window.location.pathname);
              }
            } catch (erroUrl) {
              console.warn("Não foi possível limpar o URL:", erroUrl);
            }

            // 2. Abre o perfil JÁ.
            setEcraAtivo('perfil');

            // 3. E só agora refresca os dados, sem bloquear a navegação.
            const user = auth.currentUser;
            if (!user) return;
            getDoc(doc(db, "utilizadores", user.uid))
              .then((snap) => {
                if (!snap.exists()) return;
                setDadosUtilizador({ uid: user.uid, ...snap.data() });
              })
              .catch((erro) => {
                console.error("Não foi possível refrescar o teu perfil:", erro);
              });
          }} 
          style={{ cursor: 'pointer' }} 
        />
      </div>

    {/* MENU DE SALDO - MONETIZAÇÃO PREMIUM PROTOCOLO EXTERNO & MULTILÍNGUE */}
      {mostrarMenuSaldo && (
        <div className="modal-overlay">
          <div className="saldo-menu" style={{ border: '2px solid rgba(57, 255, 20, 0.4)', boxShadow: '0 0 25px rgba(57, 255, 20, 0.2)' }}>
            <div className="menu-header">
              <h2>
                {
                  {
                    pt: "COMPRAR BOLAS",
                    en: "BUY COINS",
                    es: "COMPRAR BOLAS",
                    fr: "ACHETER DES PIÈCES"
                  }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || "BUY COINS"
                }
              </h2>
              <button onClick={() => setMostrarMenuSaldo(false)} style={{ color: '#39FF14', fontWeight: 'bold' }}>X</button>
            </div>
            
            {/* VALORES E PACOTES EM EXIBIÇÃO NA MONTRA - ARRANCANDO NOS 10€ ANTI-TAXAS */}
            <div className="valores-grid">
                          {[1, 5, 10, 25, 50, 100, 250, 350, 500].map(valor => {
                let bolas = valor === 1 ? 850 : valor === 5 ? 4250 : valor === 10 ? 8500 : valor === 25 ? 22000 : valor === 50 ? 45000 : valor === 100 ? 100000 : valor === 250 ? 275000 : valor === 350 ? 400000 : 600000;
                return (
                  <button
                    key={valor}
                    className="valor-btn"
                    onClick={() => {
                      const uid = auth?.currentUser?.uid;

                      const tSaldoAlertas = {
                        pt: {
                          login: "Por favor, faz login para entrares no estádio.",
                          brevemente: "Carregamentos de BOLAS brevemente disponíveis. Estamos a preparar uma experiência de pagamento incrível! 🏟️⚽"
                        },
                        en: {
                          login: "Please log in to enter the stadium.",
                          brevemente: "COIN top-ups available soon. We are preparing an incredible payment experience! 🏟️⚽"
                        },
                        es: {
                          login: "Por favor, inicia sesión para entrar al estadio.",
                          brevemente: "Recargas de BOLAS disponibles próximamente. ¡Estamos preparando una experiencia de pago increíble! 🏟️⚽"
                        },
                        fr: {
                          login: "Veuillez vous connecter pour entrer dans le stade.",
                          brevemente: "Recharges de PIÈCES bientôt disponibles. Nous préparons une expérience de paiement incroyable ! 🏟️⚽"
                        }
                      }[(navigator.language || navigator.userLanguage).toLowerCase().split('-')] || {
                        login: "Please log in to enter the stadium.",
                        brevemente: "COIN top-ups available soon. 🏟️⚽"
                      };

                      if (!uid) {
                        alert(tSaldoAlertas.login);
                        return;
                      }

                      // ==========================================================
                      // 🚀 LINK EXTERNO FUTURO REDIRECT (STRIPE / PAYPAL ETC.)
                      // quando definires a gateway, basta substituir o alert abaixo por:
                      // window.open(`https://teu-link-externo.com{uid}&amount=${valor}`, '_blank');
                      // ==========================================================
                      alert(tSaldoAlertas.brevemente);
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <span style={{ color: '#39FF14', fontWeight: 'bold', fontSize: '14px' }}>⚽ {bolas.toLocaleString()}</span>
                      <small style={{ color: '#aaa', fontSize: '11px', marginTop: '4px', fontWeight: 'bold' }}>{valor.toFixed(2)}€</small>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

          {/* POPUP DE NOVA PUBLICAÇÃO - MULTILÍNGUE GLOBAL COM PERCENTAGEM */}
      {arquivoParaPostar && (
        <div className="modal-overlay" style={{ zIndex: 10000 }}>
          <div className="comentarios-menu" style={{ height: 'auto', padding: '20px' }}>
            <h3 style={{ color: '#39FF14', textAlign: 'center', fontWeight: '900' }}>
              {(() => {
                const lg = (navigator.language || navigator.userLanguage || "en").toLowerCase();
                if (lg.startsWith('pt')) return "NOVA PUBLICAÇÃO";
                if (lg.startsWith('es')) return "NUEVA PUBLICACIÓN";
                if (lg.startsWith('fr')) return "NOUVEAU POST";
                return "NEW POST";
              })()}
            </h3>
            <textarea 
              className="neon-input-chat" 
              style={{ width: '100%', height: '80px', marginTop: '10px', borderRadius: '10px', resize: 'none', padding: '10px', boxSizing: 'border-box' }}
              placeholder={(() => {
                const lg = (navigator.language || navigator.userLanguage || "en").toLowerCase();
                if (lg.startsWith('pt')) return "Descrição...";
                if (lg.startsWith('es')) return "Descripción...";
                if (lg.startsWith('fr')) return "Légende...";
                return "Caption...";
              })()}
              value={(legenda.startsWith('A carregar') || legenda.startsWith('Upload') || legenda.startsWith('Cargando') || legenda.startsWith('Chargement')) ? '' : legenda}
              onChange={(e) => setLegenda(e.target.value)}
              disabled={carregando}
            />
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button 
                className="send-btn" 
                style={{ background: '#ff4d4d', flex: 1, opacity: carregando ? 0.5 : 1, cursor: 'pointer', border: 'none', borderRadius: '10px', padding: '12px', fontWeight: 'bold', color: 'white' }} 
                disabled={carregando} 
                onClick={() => { setLegenda(''); setArquivoParaPostar(null); }}
              >
                {(() => {
                  const lg = (navigator.language || navigator.userLanguage || "en").toLowerCase();
                  if (lg.startsWith('pt')) return "Cancelar";
                  if (lg.startsWith('es')) return "Cancelar";
                  if (lg.startsWith('fr')) return "Annuler";
                  return "Cancel";
                })()}
              </button>
              
              <button 
                className="send-btn" 
                style={{ flex: 1, background: carregando ? '#555' : '#39FF14', color: carregando ? '#aaa' : '#000', opacity: carregando ? 0.7 : 1, cursor: 'pointer', border: 'none', borderRadius: '10px', padding: '12px', fontWeight: 'bold' }} 
                disabled={carregando} 
                onClick={() => confirmarPostagem()}
              >
                {carregando ? (legenda || "...") : (() => {
                  const lg = (navigator.language || navigator.userLanguage || "en").toLowerCase();
                  if (lg.startsWith('pt')) return "Publicar";
                  if (lg.startsWith('es')) return "Publicar";
                  if (lg.startsWith('fr')) return "Publier";
                  return "Post";
                })()}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Feed;

// PROCESSA O VENCEDOR DO RANKING DOS 5 PORCENTO NO MOMENTO DO FECHO (BLOCO DO TOSHIBA LIGADO AO MUNDO)
export const processarPremioRankingLive = async (db, auth) => {
  try {
    const { collection, query, orderBy, limit, getDocs, writeBatch, doc: dDoc, setDoc: fSetDoc, serverTimestamp } = await import('firebase/firestore');
    const idCanalDono = auth.currentUser?.uid;
    if (!idCanalDono) return;

    const refSubColecaoRanking = collection(db, "lives_activas", idCanalDono, "ranking");
    const qVencedor = query(refSubColecaoRanking, orderBy("totalGasto", "desc"), limit(1));
    const snapVencedor = await getDocs(qVencedor);

    if (!snapVencedor.empty) {
      const docVencedor = snapVencedor.docs[0];
      const dadosVencedor = docVencedor.data();

      if (dadosVencedor && dadosVencedor.totalGasto > 0) {
        const moedasRetorno = dadosVencedor.retornoAcumulado || Math.floor(dadosVencedor.totalGasto * 0.05);
        
        if (moedasRetorno > 0) {
          // Dicionário de tradução para a push de recompensa do maior presenteador do estádio
          const tPremioRanking = {
            pt: {
              fallbackAnfitriao: "Anfitrião",
              texto: `Parabéns! Foste o maior presenteador da Live de ${auth.currentUser?.displayName || "Anfitrião"}! Tens um bónus de ${moedasRetorno} ⚽ para resgatar!`
            },
            en: {
              fallbackAnfitriao: "Host",
              texto: `Congratulations! You were the top gifter on ${auth.currentUser?.displayName || "Host"}'s Live Stream! You have a bonus of ${moedasRetorno} ⚽ to claim!`
            },
            es: {
              fallbackAnfitriao: "Anfitrión",
              texto: `¡Felicitaciones! ¡Fuiste el mayor donante en el Live de ${auth.currentUser?.displayName || "Anfitrión"}! ¡Tienes un bono de ${moedasRetorno} ⚽ para canjear!`
            },
            fr: {
              fallbackAnfitriao: "Hôte",
              texto: `Félicitations ! Vous avez été le plus grand donateur do Live de ${auth.currentUser?.displayName || "Hôte"} ! Vous avez un bonus de ${moedasRetorno} ⚽ à réclamer !`
            }
          };

          // Deteta o idioma do smartphone do vencedor (ou adota inglês se falhar)
          const idiomaVencedor = (navigator.language || navigator.userLanguage).toLowerCase().split('-')[0];
          const tRank = tPremioRanking[idiomaVencedor] || tPremioRanking.en;

          const refPremioFixo = dDoc(db, "utilizadores", dadosVencedor.userId, "notificacoes", `premio_live_${idCanalDono}_${Date.now()}`);
          await fSetDoc(refPremioFixo, {
            tipo: 'recompensa_ranking_live',
            lida: "false",
            remetenteId: idCanalDono,
            remetenteNome: auth.currentUser?.displayName || "Dono da Live",
            timestamp: serverTimestamp(),
                        // Calcula o prazo estrito de 7 dias para a frente (Bloco do Toshiba)
            expiraEm: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
            dados: {
              tipo: 'recompensa_ranking_live',
              lida: "false",
              valorPremio: moedasRetorno,
              donoNome: auth.currentUser?.displayName || tRank.fallbackAnfitriao,
              textoCustom: tRank.texto,
              expiraEm: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
            }
          });
        }
      }
    }

    const snapshotCompleto = await getDocs(refSubColecaoRanking);
    if (!snapshotCompleto.empty) {
      const loteEliminacao = writeBatch(db);
      snapshotCompleto.docs.forEach((documento) => {
        loteEliminacao.delete(documento.ref);
      });
      await loteEliminacao.commit();
    }
  } catch (err) {
    console.error("Erro no processamento isolado do prémio do ranking:", err);
  }
};

